"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JA = void 0;
// Do not edit manually!!
// When editing, edit 40_data/locales/resources.js
// It is generated automatically when you edit and save resources.js

const JA = exports.JA = {
  "label.core.language_setting": "言語設定(Language)",
  "label.core.font_size": "文字サイズ変更",
  "label.core.home": "ホーム",
  "label.core.to_return_home": "ホームへ戻る",
  "label.core.to_return_search_list": "検索一覧へ戻る",
  "label.core.to_return_history_list": "履歴一覧へ戻る",
  "label.core.ok": "OK",
  "label.core.cancel": "キャンセル",
  "label.core.save": "保存",
  "label.core.confirm": "確認",
  "label.core.help": "ヘルプ",
  "label.core.not_registered": "未登録",
  "label.core.register": "登録",
  "label.core.update": "更新",
  "label.core.modify": "変更",
  "label.core.select": "選択",
  "label.core.delete": "削除",
  "label.core.temp_store": "一時保存",
  "label.core.add_file": "ファイル追加",
  "label.core.delete_any": "{0}削除",
  "label.core.add_any": "{0}追加",
  "label.core.required": "必須",
  "label.core.required_message": "入力してください。",
  "label.core.required_item_message": "{0}を入力してください。",
  "label.core.specify_message": "{0}を指定してください。",
  "label.core.floor_message": "半角数字か、入力例の形式で入力してください。",
  "label.core.not_specified_message": "該当の{0}を指定することはできません。",
  "label.core.length_message": "{0}文字以内で入力してください。",
  "label.core.length_within_message": "{0}は{1}文字以内で入力してください。",
  "label.core.length_min_message": "{0}文字以上で入力してください。",
  "label.core.length_least_message": "{0}は{1}文字以上で入力してください。",
  "label.core.not_allowed_character": "文字「{0}」は使用できません。",
  "label.core.contains_non_alphanumeric_message": "{0}に半角英数字以外の文字が含まれています。",
  "label.core.cannot_use_char_message": "使用することができない文字が含まれています。",
  "label.core.mix_message": "必ず英字と数字を混在させたものを指定してください。",
  "label.core.incorrect_message": "{0}が正しくありません。",
  "label.core.enter_invalid_message": "{0}に不正な値が入力されています。",
  "label.core.already_registered_message": "{0}はすでに登録されています。",
  "label.core.validate_message": "入力内容を確認してください。",
  "label.core.registered_message": "以下の内容で登録しました。",
  "label.core.updated_message": "以下の内容で更新しました。",
  "label.core.deleted_message": "以下の内容を削除しました。",
  "label.core.clear_confirm_message": "入力内容を全てクリアします。よろしいですか？",
  "label.core.register_confirm_message": "この内容で登録します。よろしいですか？",
  "label.core.csv_register_errinfo_message": "CSVデータ不正により登録できなかったデータの該当行、エラー内容は以下の通りです。",
  "label.core.csv_format_error_message": "CSVデータ形式が不正です。",
  "label.core.update_confirm_message": "この内容で更新します。よろしいですか？",
  "label.core.delete_confirm_message": "この内容を削除します。よろしいですか？",
  "label.core.setting_confirm_message": "この内容で設定します。よろしいですか？",
  "label.core.temporarily_saved_confirm_message": "この内容で一時保存します。よろしいですか？",
  "label.core.temp_store_message": "{0}を一時保存しました。",
  "label.core.no_search_result_message": "検索条件に一致する情報がありません。",
  "label.core.connection_error_message": "通信に失敗しました。",
  "label.core.file_not_found_message": "ファイルが見つかりません。",
  "label.core.empty_file_message": "ファイルが存在しないか、または空のファイルです。",
  "label.core.please_select": "選択してください。",
  "label.core.please_select_replace": "{0}を選択してください。",
  "label.core.please_enter_keyword": "キーワードを入力してください。",
  "label.core.no_item_match": "キーワードに一致する項目がありません。",
  "label.core.no_match": "{0}と一致しません。",
  "label.core.enter_half_numeric": "半角数字で入力してください。",
  "label.core.value_least_message": "{0}以上の数値で入力してください。",
  "label.core.enter_value_between": "{0}～{1}の値を入力してください。",
  "label.core.contact_us": "お問い合わせ",
  "label.core.manual": "マニュアル",
  "label.core.faq": "FAQ",
  "label.core.configuration": "設定",
  "label.core.one_nec": "One NEC 事業継続支援システム",
  "label.core.full_name": "姓名",
  "label.core.company_name": "会社名",
  "label.core.organization_name": "組織名",
  "label.core.job_classification": "職位分類",
  "label.core.usage_rights": "利用権限",
  "label.core.update_target": "更新対象",
  "label.core.kaisha_soshiki_select_placeholder": "会社／組織を選択してください。",
  "label.core.soshiki_select_placeholder": "組織を選択してください。",
  "label.core.please_select_soshiki_lv4_or_more": "部門Lv４以上を選択してください。",
  "label.core.tdfk": "都道府県",
  "label.core.tdfk_select": "都道府県選択",
  "label.core.tdfk_building": "都道府県／建物",
  "label.core.tdfk_building_select": "都道府県／建物選択",
  "label.core.tdfk_building_site": "都道府県／建物／拠点",
  "label.core.tdfk_building_site_select": "都道府県／建物／拠点選択",
  "label.core.tdfk_site": "都道府県／拠点",
  "label.core.user_select": "ユーザ選択",
  "label.core.admin_select": "管理者選択",
  "label.core.admin_select_help": "管理者として設定したユーザは、Biz安否確認／一斉通報でグループを利用して安否確認できます。",
  "label.core.select_all": "全て選択",
  "label.core.datetime_format": "YYYY/MM/DD HH:mm:ss",
  "label.core.system_error_message": "ログインに失敗しました。再度ログインしてください。",
  "label.core.system_error_page_message": "画面が正しく表示できません。ブラウザの画面を再読み込み（リフレッシュ※PCではCtrl+F5）してください。\n同様のメッセージが繰り返し表示される場合は、ITサービスポータル(https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91)へご連絡ください。",
  "label.core.error_occured_time": "エラー発生日時 :{0}",
  "label.core.disaster_info": "災害情報",
  "label.core.disaster_name": "災害名",
  "label.core.disaster_level": "災害レベル",
  "label.core.search_start_date": "検索開始日時",
  "label.core.detail": "詳細",
  "label.core.history": "履歴",
  "label.core.registered_date": "登録日時",
  "label.core.update_date": "更新日",
  "label.core.personal_information_handling_policy": "個人情報取り扱い方針",
  "label.core.unauthorized": "サーバ認証エラー",
  "label.core.double_submit": "処理中です。",
  "label.core.direct": "直属",
  "label.core.select_tdfk_hint": "災害情報が選択されている場合、<br/>災害情報に紐づく災害発生都道府県の災害レベルが表示されます。",
  "label.core.disaster_level_3": "震度６強 ～ ７",
  "label.core.disaster_level_2": "震度５強 ～ ６弱",
  "label.core.disaster_level_1": "震度４ ～ ５弱",
  "label.core.special_warning": "特別警報",
  "label.core.volcano_warning": "噴火警報（居住地域）",
  "label.core.disaster_level_meaning": "・地震：{0}",
  "label.core.weather_warning_meaning": "・気象警報：{0}",
  "label.core.volcano_warning_meaning": "・噴火：{0}",
  "label.core.building": "建物",
  "label.core.building_hint": "選択した都道府県にある建物がリストに表示されます。<br/>建物は複数選択が可能です。",
  "label.core.setting_information_disp": "ホーム表示設定",
  "label.core.work_place": "勤務場所",
  "label.core.home_place": "自宅場所",
  "label.core.other_stay_place": "その他滞在場所",
  "label.core.note": "備考",
  "label.core.kaisha_soshiki": "会社／組織",
  "label.core.freeword_hint": "フリーワード検索をご利用できます。<br/>スペース区切りで5ワードまで指定が可能です。",
  "label.core.target": "対象",
  "label.core.non_target": "対象外",
  "label.core.setup_complete": "設定が完了しました。",
  "label.core.show_all": "全て表示",
  "label.core.show_detail": "詳細表示",
  "label.core.all": "全て",
  "label.core.complete": "完了",
  "label.core.not_complete": "未完了",
  "label.core.normal_display": "通常表示",
  "label.core.kaisha_soshiki_select": "会社／組織選択",
  "label.core.user_num": "ユーザ数",
  "label.core.includes_worker": "構内作業者を含む",
  "label.core.building_name": "建物名",
  "label.core.base_name": "拠点名",
  "label.core.base": "拠点",
  "label.core.totalize_conditions": "集計条件",
  "label.core.totalize_result": "集計結果一覧",
  "label.core.totalize": "集計",
  "label.core.total": "合計",
  "label.core.people": "人",
  "label.core.goutou": "号棟",
  "label.core.floor": "階",
  "label.core.hierarchy": "階",
  "label.core.workspace": "フロア",
  "label.core.search_conditions": "検索条件",
  "label.core.optional_search_conditions": "オプション検索条件",
  "label.core.search": "検索",
  "label.core.search_result_list": "検索結果一覧",
  "label.core.error_list": "エラー一覧",
  "label.core.error_contents": "エラー内容",
  "label.core.line": "行",
  "label.core.group_name": "グループ名",
  "label.core.user": "ユーザ",
  "label.core.company": "会社",
  "label.core.organization": "組織",
  "label.core.view_num_list": "{0}件表示",
  "label.core.list_count_disp_all": "全{0}件：",
  "label.core.list_count_disp_detail": "{0} - {1}件を表示",
  "label.core.registered_person": "登録者",
  "label.core.other": "その他",
  "label.core.year": "年",
  "label.core.month": "月",
  "label.core.day": "日",
  "label.core.hour": "時",
  "label.core.minute": "分",
  "label.core.disaster_info_hint": "災害情報を選択すると、災害情報に紐づく災害発生日時が検索開始日時に設定されます。",
  "label.core.content": "内容",
  "label.core.invalid_date_message": "正しい日付を選択してください。",
  "label.core.invalid_datetime_message": "正しい日時を選択してください。",
  "label.core.setting_display": "表示設定",
  "label.core.srh_start_dt_time_check_msg": "開始日時は終了日時より古い日時を指定してください。",
  "label.core.srh_start_dt_check_msg": "開始日は終了日より古い日付を指定してください。",
  "label.core.post": "掲載先",
  "label.core.select_post": "掲載先選択",
  "label.core.set_post": "掲載先設定",
  "label.core.confirm_before_move": "変更した内容が破棄されます。よろしいですか？<br/>OKを押すと情報を変更せずに画面が移ります。キャンセルを押すと元の画面に戻ります。",
  "label.core.already_been_deleted": "該当する情報がありません。すでに削除されている可能性があります。",
  "label.core.no_data_to_display": "表示対象データがありません。",
  "label.core.user_id": "ユーザＩＤ",
  "label.core.history_list": "履歴一覧",
  "label.core.register_result_supplement": "登録内容に誤りがある場合は、更新画面より修正を行ってください。",
  "label.core.close": "閉じる",
  "label.core.select_bcp_tgt_jigyo": "BCP対象事業選択",
  "label.core.refer_bcp_tgt_jigyo": "BCP対象事業参照",
  "label.core.bcp_tgt_jigyo_cd": "BCP対象事業コード",
  "label.core.bcp_tgt_jigyo_name": "BCP対象事業名",
  "label.core.data_not_found_message": "該当データが存在しません。",
  "label.core.run": "実行",
  "label.core.document_upload_delete": "ドキュメントアップロード／削除",
  "label.core.document_upload_delete_complete": "ドキュメントアップロード／削除完了",
  "label.core.upload_target": "アップロード対象",
  "label.core.delete_target": "削除対象",
  "label.core.delete_target_message": "削除対象",
  "label.core.training_name": "訓練名",
  "label.core.implementation_period": "実施時期",
  "label.core.bcp_tgt_jigyo": "BCP対象事業",
  "label.core.target_document": "対象ドキュメント",
  "label.core.uploaded_file_information": "アップロード済みファイル情報",
  "label.core.deleted_file_information": "削除ファイル情報",
  "label.core.file_name": "ファイル名",
  "label.core.description": "説明書き",
  "label.core.last_upload_date": "前回アップロード日時",
  "label.core.upload_datetime": "アップロード日時",
  "label.core.upload_delete": "アップロード／削除",
  "label.core.upload": "アップロード",
  "label.core.upload_file": "アップロードファイル",
  "label.core.edition_number": "版数",
  "label.core.contact_information_update": "BCP推進者問合せ先更新",
  "label.core.contact_information": "各部門BCP推進者お問い合わせ先",
  "label.core.file_upload_complete": "ファイルのアップロードが完了しました。",
  "label.core.file_upload_failed": "ファイルのアップロードが失敗しました。",
  "label.core.file_delete_complete": "ファイルの削除が完了しました。",
  "label.core.file_selection": "ファイル選択",
  "label.core.document_edition_number_message": "半角数字３桁で入力してください。",
  "label.core.file_size_large_message": "ファイルのサイズが大きすぎます。",
  "label.core.unable_enter_future_date": "未来日は選択できません。",
  "label.core.incorrect_range_message": "{0}以上{1}以下の半角数字で入力してください。",
  "label.core.filter_dt_disaster_hint": "災害情報を選択すると、災害情報に紐づく災害発生日時が絞込日時に設定されます。",
  "label.core.location": "所在地",
  "label.core.select_building": "建物選択",
  "label.core.select_site": "拠点選択",
  "label.core.sort_update": "並べ替え",
  "label.core.sort_top": "一番上へ",
  "label.core.sort_up": "一つ上へ",
  "label.core.sort_down": "一つ下へ",
  "label.core.sort_tail": "一番下へ",
  "label.core.mail_address": "メールアドレス",
  "label.core.to_return_detail": "詳細へ戻る",
  "label.core.attached_file": "添付ファイル",
  "label.core.last_upd_user": "最終更新者",
  "label.core.clear": "クリア",
  "label.core.select_tdfk_all": "47都道府県全てを選択",
  "label.core.volcano": "火山",
  "label.core.sort_update_confirm_msg": "並び順を更新します。よろしいですか？",
  "label.core.last_updated_date": "最終更新日時",
  "label.core.loading_message": "情報取得中...",
  "label.common.disaster_guidelin": "<b>注意・閲覧制限事項</b>\n    <ul>\n      <li>ブラウザは「Microsoft Edge」で動作確認を行っています。 その他ブラウザでは正常に表示されない場合があります。</li>\n      <li>ブラウザの「戻る」ボタン等は正常に動作しない可能性がありますので利用しないでください。画面内のボタンを利用してください。</li>\n    </ul>\n    <b>システム提供機能について</b>\n    <ul>\n      <li>\n        各社間、各NEC関係部門間で地域被災状況や部門情報の共有ができます。<br/>\n        また各社、各NEC関係部門から自社、自部門の勤務者向けに指示事項を掲示できます。\n      </li>\n      <li>事業継続業務の内部監査ができます。</li>\n      <li>事業継続に関する各種資料が閲覧できます。</li>\n    </ul>\n    ",
  "label.common.precautions": "注意事項・制限事項等",
  "label.common.new_info": "新着",
  "label.common.no_info": "過去{0}日の情報はありません。",
  "label.common.syslogin_input_error": "ログインIDが正しくありません。",
  "label.common.syslogin_system_title": "One NEC 事業継続支援システム",
  "label.common.syslogin_title": "ログイン",
  "label.common.syslogin_id": "ログインID",
  "label.common.syslogin_login": "ログイン",
  "label.common.syslogin_about_system": "このシステムについて",
  "label.common.syslogin_privacy_policy": "個人情報取り扱い方針",
  "label.common.system_login_message": "ただいま{0}にログイン中です。<br/>そのまましばらくお待ちください。",
  "label.common.syslogin_hint": "<div style='font-weight:bold'>ログインＩＤについて</div>\n    <small>\n      NEC-Gアカウント(for クラウド)を入力し、ログインしてください。\n    </small>",
  "label.common.syslogin_system_unavailable": "所属している会社は現在システムを利用できない状態となっています。お手数ですが、システムの管理者へご連絡ください。",
  "label.common.syslogin_privacy_policy_not_agree": "個人情報取り扱い方針に同意いただけない場合はご利用できません。",
  "label.common.sitemap_business": "業務",
  "label.common.sitemap_description": "説明",
  "label.common.faq_search_by_category": "分類から探す",
  "label.common.faq_category": "分類",
  "label.common.faq_search_by_access": "閲覧数の多い質問から探す",
  "label.common.faq_displaying_all": "全{0}件",
  "label.common.faq_view_image": "画像を表示",
  "label.common.faq_frequently_accessed": "閲覧数の多い質問[{0}]",
  "label.common.faq_hide_image": "画像を非表示",
  "label.common.faq_search_with_words": "{0}で検索した結果",
  "label.common.faq_not_found": "該当するFAQが見つかりません。",
  "label.common.faq_search_word": "「{0}」",
  "label.common.manual_list": "マニュアル一覧",
  "label.common.manual_list_en": "Manual list（English Version）",
  "label.common.manual_grouphisai": "NECグループ被災情報機能操作マニュアル",
  "label.common.manual_grouphisai_en": "Group Damage Info Operation Manual",
  "label.common.manual_sitebuildingarea": "拠点・建物・地域情報機能操作マニュアル",
  "label.common.manual_personal": "個人情報設定機能操作マニュアル",
  "label.common.manual_personal_en": "Setting Personal Information Operation Manual",
  "label.common.manual_bizexcsetting": "安否確認対象外設定機能操作マニュアル",
  "label.common.manual_bizexcsetting_en": "Safety Confirmation Excluded Setting Operation Manual",
  "label.common.safety_title": "安否登録・安否確認について",
  "label.common.safety_setting_personal": "個人情報設定",
  "label.common.safety_not_setting": "（未設定）",
  "label.common.safety_register_criteria_pdf": "安否登録基準<br/>（PDFファイル）",
  "label.common.safety_confirmation_external_link": "Biz安否確認／一斉通報<br/>（外部リンク）",
  "label.common.safety_overview": "■安否登録／確認、お知らせの機能は、Biz安否確認／一斉通報サービスをご利用ください。<br/>\n        Biz安否確認／一斉通報サービスをご利用前または勤務場所等が変更となった場合、<br/>\n        個人情報設定の内容をご確認いただき、内容に変更ある場合は設定変更をお願いいたします。<br/>\n        個人情報設定の設定がされていない場合、Biz安否確認／一斉通報サービスの一部機能がご利用できません。<br/>\n        ・災害発生時などのアプリまたはメールでの通知<br/>\n        ・パスワードを忘れた場合のパスワードリセット<br/>\n        等",
  "label.common.biz_mail_info": "■Biz安否確認／一斉通報サービスからの通知は「anpi@mob-connect.com」から届きます。<br/>\n        このメールアドレスはNECグループのドメインとは異なりますが、不審なメールではありません。",
  "label.common.safety_app_install": "■Biz安否確認／一斉通報サービスのアプリインストールはこちらから",
  "label.common.safety_iphone_message": "・iPhoneをご利用の方はこちら",
  "label.common.safety_android_message": "・Androidをご利用の方はこちら",
  "label.common.logout_faild": "ログアウトに失敗しました。再度ログアウトしてください。",
  "label.masterdata.disaster_register": "災害情報登録",
  "label.masterdata.disaster_update": "災害情報更新",
  "label.masterdata.disaster_delete": "災害情報削除",
  "label.masterdata.disaster_register_result": "災害情報登録結果",
  "label.masterdata.disaster_update_result": "災害情報更新結果",
  "label.masterdata.disaster_delete_result": "災害情報削除結果",
  "label.masterdata.disaster_detail": "災害情報詳細",
  "label.masterdata.disaster_training": "災害／訓練",
  "label.masterdata.disaster": "災害",
  "label.masterdata.training": "訓練",
  "label.masterdata.disaster_name": "災害名",
  "label.masterdata.disaster_datetime": "災害発生日時",
  "label.masterdata.disaster_level_tdfk": "災害レベル毎都道府県",
  "label.masterdata.disaster_level": "災害レベル",
  "label.masterdata.disaster_lv1": "レベル１",
  "label.masterdata.disaster_lv2": "レベル２",
  "label.masterdata.disaster_lv3": "レベル３",
  "label.masterdata.disaster_register_help": "本画面はOneNECとしての災害情報を登録する画面です。<br/>\n    Biz安否確認／一斉通報サービスでの災害情報はBiz安否確認／一斉通報サービスで登録する必要があります。",
  "label.masterdata.disaster_register_name_hint": "<div style='width:350px'>災害名称を設定します。<br/>\n    災害／訓練で「訓練」を選択した場合は、登録時の災害名称に自動的に【訓練】が付与されます。<br/>\n    例）【訓練】20190510_パブリック品質推進本部</div>",
  "label.masterdata.disaster_register_tdfk_hint": "災害発生都道府県ごとの災害レベルを設定します。\n      <div style='padding-top: 8px; width: 100%; display: flex; flex-wrap: wrap;'>\n        <div style='font-weight: bold;'>災害レベル</div>\n        <div style='margin-left: 2px; text-align: center; height: auto; width:20px; background-color: #FF4B00; border-radius: 4px;'>\n          <span style='color: black; font-weight: bold'>3</span>\n        </div>\n      </div>\n      <div style='margin: 0 0 8px 0'>・地震：震度６強 ～ ７</div>\n      <div style='margin: 0 0 8px 0'>・津波：大津波警報</div>\n      <div style='padding-top: 8px; width: 100%; display: flex; flex-wrap: wrap;'>\n        <div style='font-weight: bold;'>災害レベル</div>\n        <div style='margin-left: 2px; text-align: center; height: auto; width:20px; background-color: #FFF100; border-radius: 4px;'>\n          <span style='color: black; font-weight: bold'>2</span>\n        </div>\n      </div>\n      <div style='margin: 0 0 8px 0'>・地震：震度５強 ～ ６弱</div>\n      <div style='margin: 0 0 8px 0'>・気象警報：特別警報</div>\n      <div style='margin: 0 0 8px 0'>・噴火：噴火警報（居住地域）</div>\n      <div style='padding-top: 8px; width: 100%; display: flex; flex-wrap: wrap;'>\n        <div style='font-weight: bold;'>災害レベル</div>\n        <div style='margin-left: 2px; text-align: center; height: auto; width:20px; background-color: #4DC4FF; border-radius: 4px;'>\n          <span style='color: black; font-weight: bold'>1</span>\n        </div>\n      </div>\n      <div style='margin: 0 0 8px 0'>・地震：震度４ ～ ５弱</div>",
  "label.masterdata.disaster_search": "災害情報検索",
  "label.masterdata.disaster_name_already_exists_message": "入力した名前の災害は既に存在します。",
  "label.masterdata.rightusage_setting": "利用権限設定",
  "label.masterdata.training_included_or_nonincluded": "訓練情報を含む",
  "label.masterdata.disaster_tdfk_duplicate_message": "都道府県が重複しています。",
  "label.masterdata.csv_file": "CSVファイル",
  "label.masterdata.csv_select": "CSVファイル選択",
  "label.masterdata.user_unit_group_name": "グループ名",
  "label.masterdata.user_unit_group_name_help": "３６文字以内",
  "label.masterdata.user_id": "ユーザID",
  "label.masterdata.user_id_help": "会社コード＋社員ID",
  "label.masterdata.user_unit_group_role": "グループの役割",
  "label.masterdata.user_unit_group_role_help": "管理者：1 管理者／メンバ：2 メンバ：3",
  "label.masterdata.master_register_item_name_help": "項目名",
  "label.masterdata.master_register_description_help": "説明",
  "label.masterdata.group_register_data_help": "グループデータ",
  "label.masterdata.group_register_template_help": "・グループデータテンプレートファイル",
  "label.masterdata.return_register_result": "登録結果へ戻る",
  "label.masterdata.group_registration": "グループ登録",
  "label.masterdata.group_update": "グループ更新",
  "label.masterdata.group_delete": "グループ削除",
  "label.masterdata.group_registration_result": "グループ登録結果",
  "label.masterdata.group_update_result": "グループ更新結果",
  "label.masterdata.group_delete_result": "グループ削除結果",
  "label.masterdata.group_creator": "作成者",
  "label.masterdata.group_creator_company": "作成者の会社名",
  "label.masterdata.group_creator_organization": "作成者の組織名",
  "label.masterdata.group_user_delete_confirm_message": "選択したユーザをグループから削除します。よろしいですか？",
  "label.masterdata.group_csv_failed_register_message": "登録データが0件でした。",
  "label.masterdata.group_member_no_added_message": "ユーザが追加されていません。",
  "label.masterdata.user_list": "ユーザ一覧",
  "label.masterdata.admin_list": "管理者一覧",
  "label.masterdata.group_name_already_exists_message": "入力したグループ名のグループは既に存在します。",
  "label.masterdata.group_member_no_selected": "グループメンバを選択してください。",
  "label.masterdata.group_admin_no_selected": "グループ管理者を選択してください。",
  "label.masterdata.group_konai_on_hint": "初期値はON（構内作業者を検索に含む）となっています。<br/>\n         検索対象に構内作業者を含めない場合はスイッチをOFF（左）にしてください。",
  "label.masterdata.csv_file_registration": "CSVファイル登録",
  "label.masterdata.group_registration_csv": "グループCSV登録",
  "label.masterdata.return_group_registration": "グループ登録へ戻る",
  "label.masterdata.group_csv_registration_result": "グループCSV登録結果",
  "label.masterdata.group_csv_help": "CSVファイルフォーマット<br/>１：ユーザグループ名（必須）（３０文字以内）<br/>２：ユーザID（必須）（会社コード＋社員ID）\n    <p>登録例：NEC情報連携グループ,0000010123456</p>\n    ・ファイルはCSV形式（半角カンマ区切り）のテキストファイルです。<br/>\n    ・文字コードはShift-JISです。<br/>\n    ・改行コードは0x0D0A（CR + LF）です。<br/>\n    ・CSVファイル中に登録できない行が存在した場合には、次の行に処理が移ります。<br/>\n    ・既に登録されているユーザグループ名は使用できません。<br/>\n    ・既に登録されているグループに対して、メンバの追加や削除をしたい場合は、グループ検索機能から実施してください。<br/>\n    ・１ファイルにつき、１つのユーザグループのみ登録できます。<br/>\n    ・ログイン者は自動的にユーザグループにメンバとして登録されます。",
  "label.masterdata.group_csv_register_outline_help": "グループ登録用CSVファイルのテンプレートファイルをダウンロードし、ヘッダ情報を参考にしてファイルを作成してください。<br/>テンプレートファイルには、1行目に項目名、2行目にデータの補足情報が記述されています。<br/>最初の2行を削除せずに3行目からデータを記述し、そのままアップロードしてください。",
  "label.masterdata.group_csv_register_comment_help": "※ファイルはCSV形式（半角カンマ区切り）のテキストファイルです。<br/>\n         ※文字コードはShift-JISです。<br/>\n         ※改行コードは0x0D0A（CR + LF）です。<br/>\n         ※CSVファイル中に登録できない行が存在した場合には、次の行に処理が移ります。",
  "label.masterdata.group_register_comment_help": "※既に登録されているグループ名は使用できません。<br/>\n         ※既に登録されているグループに対して、メンバの追加や削除をしたい場合は、グループ検索機能から実施してください。<br/>\n         ※１ファイルにつき、１つのグループのみ登録できます。<br/>\n         ※管理者はBiz安否確認／一斉通報でこのグループを利用して安否確認を行うことが出来ます。<br/>\n         ※メンバはグループを利用して安否確認を行う時の対象者になります。",
  "label.masterdata.rightusage_target_missing": "権限を変更する方を選択してください。",
  "label.masterdata.site_register_title": "拠点情報登録",
  "label.masterdata.site_register_result_title": "拠点情報登録結果",
  "label.masterdata.building_register_title": "建物情報登録",
  "label.masterdata.building_register_result_title": "建物情報登録結果",
  "label.masterdata.building_search_title": "建物情報検索",
  "label.masterdata.building_detail_title": "建物情報詳細",
  "label.masterdata.building_update_title": "建物情報更新",
  "label.masterdata.building_update_result_title": "建物情報更新結果",
  "label.masterdata.building_delete_title": "建物情報削除",
  "label.masterdata.building_delete_result_title": "建物情報削除結果",
  "label.masterdata.site_search_title": "拠点情報検索",
  "label.masterdata.site_update_title": "拠点情報更新",
  "label.masterdata.site_update_result_title": "拠点情報更新結果",
  "label.masterdata.site_detail_title": "拠点情報詳細",
  "label.masterdata.site_delete_title": "拠点情報削除",
  "label.masterdata.site_delete_result_title": "拠点情報削除結果",
  "label.masterdata.site_ordering_title": "拠点表示順設定",
  "label.masterdata.site_ordering_detail_title": "拠点表示順詳細",
  "label.masterdata.building_common_name": "建物通称",
  "label.masterdata.building_official_name": "建物正式名称",
  "label.masterdata.function": "機能",
  "label.masterdata.area": "地域",
  "label.masterdata.site_kind": "拠点の種類",
  "label.masterdata.number_of_employees": "勤務者数",
  "label.masterdata.floors": "占有フロア階",
  "label.masterdata.total_stories": "建物総階数",
  "label.masterdata.building_owner_kbn": "建物オーナー区分",
  "label.masterdata.building_owner_name": "建物オーナー名",
  "label.masterdata.building_owner_contact": "建物オーナー連絡先",
  "label.masterdata.guard_contact": "防災センター連絡先",
  "label.masterdata.location": "所在地",
  "label.masterdata.communication_means": "通信手段",
  "label.masterdata.stockpile_food": "備蓄食料",
  "label.masterdata.stockpile_drinking_water": "備蓄飲料水",
  "label.masterdata.warehouse_stored_goods": "倉庫（保管品）",
  "label.masterdata.warehouse_in_tank": "倉庫（インタンク）",
  "label.masterdata.last_updated_by": "最終更新者",
  "label.masterdata.last_updated_date": "最終更新日時",
  "label.masterdata.delete_site_link_message": "拠点を削除すると、当該拠点を{0}の勤務場所に設定している場合は、再設定が必要となります。処理を続けますか？",
  "label.masterdata.pande_report": "感染症報告",
  "label.masterdata.user_and_pande_report": "ユーザ、および感染症報告",
  "label.masterdata.tenant_sites": "入居する拠点",
  "label.masterdata.no_site": "入居拠点無し",
  "label.masterdata.no_site_hint": "ONにした場合は、入居している拠点が存在していない建物のみ表示します。",
  "label.masterdata.site_count": "拠点数",
  "label.masterdata.building_name_hint": "建物通称、建物正式名称のいずれかでの登録が可能です。",
  "label.masterdata.location_hint": "都道府県を選択し、所在地を入力してください。",
  "label.masterdata.building_exists_tenant_sites_message": "入居する拠点が存在するため、削除できません。先に拠点情報を削除してください。",
  "label.masterdata.liter": "リットル",
  "label.masterdata.serving": "食分",
  "label.masterdata.target_build_deleted_message": "対象の建物は削除されている可能性があります。",
  "label.masterdata.return_to_details": "詳細へ戻る",
  "label.masterdata.site_company_hint": "拠点情報更新画面で修正はできません。",
  "label.masterdata.site_count_changed_message": "拠点の並び順を変更する会社の拠点数が変更されています。画面を更新して、再度並び替えを実施してください。",
  "label.masterdata.my_bu_check_message": "組織名に所属NEC関係部門を選択してください。",
  "label.masterdata.tsunami_warn": "大津波警報",
  "label.masterdata.area_register_title": "地域情報登録",
  "label.masterdata.area_register_result_title": "地域情報登録結果",
  "label.masterdata.area_search_title": "地域情報検索",
  "label.masterdata.area_update_title": "地域情報更新",
  "label.masterdata.area_update_result_title": "地域情報更新結果",
  "label.masterdata.area_detail_title": "地域情報詳細",
  "label.masterdata.area_delete_title": "地域情報削除",
  "label.masterdata.area_delete_result_title": "地域情報削除結果",
  "label.masterdata.area_ordering_title": "地域表示順設定",
  "label.masterdata.area_ordering_detail_title": "地域表示順詳細",
  "label.masterdata.area_nm": "地域名",
  "label.masterdata.area_code_upper_limit_message": "地域情報の登録可能数の上限に達したため、地域情報の登録ができません。",
  "label.masterdata.area_delete_error_message": "地域に紐づく拠点が存在するため、削除できません。先に拠点情報を削除してください。",
  "label.masterdata.area_count": "地域数",
  "label.masterdata.area_count_changed_message": "地域の並び順を変更する会社の地域数が変更されています。画面を更新して、再度並び替えを実施してください。",
  "label.masterdata.sort_update_message": "並び順を更新しました。",
  "label.masterdata.hr_linkage_search": "人事拠点連携対応検索",
  "label.masterdata.hr_linkage_update": "人事拠点連携対応更新",
  "label.masterdata.hr_linkage_update_result": "人事拠点連携対応更新結果",
  "label.masterdata.linkage_status": "紐づけ状況",
  "label.masterdata.hr_system": "人事情報システム",
  "label.masterdata.onenec_system": "OneNEC事業継続支援システム",
  "label.masterdata.hr_system_site": "人事情報システムの拠点情報",
  "label.masterdata.onenec_system_site": "OneNEC事業継続支援システムの拠点情報",
  "label.masterdata.no.grouprole.message": "グループの役割を指定してください。",
  "label.masterdata.enter.invalid.grouprole.message": "グループの役割に不正な値が入力されています。",
  "label.masterdata.enter.invalid.members.message": "ユーザと管理者をそれぞれ１人以上設定してください。",
  "label.masterdata.enter.duplication.members.message": "IDが重複しています。",
  "label.masterdata.admin": "管理者",
  "label.masterdata.member": "メンバー",
  "label.masterdata.admin_member": "管理者／メンバー",
  "label.masterdata.group_search_help": "自分が管理者に設定されているグループを検索することができます。",
  "label.masterdata.site_number": "拠点番号",
  "label.masterdata.biz_exc_setting_title": "安否確認対象外設定",
  "label.masterdata.biz_exc_setting_help": "Biz安否確認／一斉通報サービスの安否確認および安否集計の対象外にしたいユーザを設定します。<br/>対象外設定を行う場合は、検索結果一覧上で対象外をONにして設定ボタンを押してください。<br/><br/>\n         ※安否対象外とする者は、例えば兼務者、構内作業者のうち災害時に別の手段（本務側で安否確認する、委託先にて安否確認をするなど）で安否確認を行うためBiz安否確認／一斉通報サービスを利用しない、または利用する必要がないようなケースを想定しています。（対象外設定されたユーザのアカウントは、Biz安否確認／一斉通報サービスから削除されます）<br/><br/>\n         休職者は原則として本システムでの安否登録対象となりますので対象外設定はしないでください。また、対象外を解除したユーザについては、再度Biz安否確認／一斉通報サービス上でパスワードの設定などの初期設定が必要になります。",
  "label.masterdata.biz_exc_seconded_hint": "出向元会社から見たときに、別会社へ出向している社員に関しては「出向中」と表示されます。<br/>表示がない社員に関しては「自社在籍」となります。",
  "label.masterdata.biz_exc_target_nontarget": "安否確認対象／対象外",
  "label.masterdata.biz_exc_target": "対象",
  "label.masterdata.biz_exc_nontarget": "対象外",
  "label.masterdata.biz_exc_seconded_nonseconded": "出向中／自社在籍",
  "label.masterdata.biz_exc_seconded": "出向中",
  "label.masterdata.biz_exc_nonseconded": "自社在籍",
  "label.masterdata.updater_name": "更新者名",
  "label.masterdata.updater_organization_name": "更新者組織名",
  "label.masterdata.excluded_setting_datetime": "対象外設定日時",
  "label.masterdata.non_existent_user": "存在しないユーザ",
  "label.masterdata.biz_exc_setting_not_changed": "対象外設定が変更されていません。",
  "label.masterdata.biz_exc_confirm_sub_message": "設定内容は翌日にBiz安否確認／一斉通報サービスに反映されます。",
  "label.masterdata.group_cannot_entry_biz_exc_user": "安否確認対象外に設定されているためグループ登録できません。",
  "label.masterdata.group_cannot_search_biz_exc_user": "安否確認対象外に設定されているためグループ検索できません。",
  "label.masterdata.biz_user_csv_upload": "利用者アップロード（CSV）",
  "label.masterdata.biz_user_csv_upload_result": "利用者アップロード（CSV）結果",
  "label.masterdata.biz_user_csv_upload_list": "利用者更新一覧",
  "label.masterdata.biz_user_csv_please_file_select": "CSVファイルを選択してください。",
  "label.masterdata.biz_user_csv_file_empty": "CSVファイルが存在しないか、または空のファイルです。",
  "label.masterdata.biz_user_csv_file_utf8": "CSVファイルがUTF-8ではありません。",
  "label.masterdata.biz_user_csv_file_extension": "CSVファイルの拡張子が「.csv」ではありません。",
  "label.masterdata.biz_user_csv_file_rec_count": "CSVファイルの件数は{0}件以内にしてください。",
  "label.masterdata.biz_user_please_enter": "{0}を入力してください。",
  "label.masterdata.biz_user_please_enter_char": "{0}は{1}文字以内で入力してください。",
  "label.masterdata.biz_user_use_id_char": "{0}は半角英数字・記号（-=^_'{}'~@.）を使用してください。",
  "label.masterdata.biz_user_id_start_end_char": "{0}の先頭と末尾に記号（-~.）は使用できません。",
  "label.masterdata.biz_user_domain_use": "{0}にはDWPで使用されているドメインを使用できません。",
  "label.masterdata.biz_user_used": "既に使用されている{0}です。",
  "label.masterdata.biz_user_dup_id": "CSVファイル内でIDが重複しています。",
  "label.masterdata.biz_user_char_use": "{0}は半角英数字を使用してください。",
  "label.masterdata.biz_user_soshiki_exist": "入力された組織コードに一致する組織が存在しません。",
  "label.masterdata.biz_user_own_org_regist": "自身が所属する会社以外の利用者登録は行えません。",
  "label.masterdata.biz_user_own_org_delete": "自身が所属する会社以外の利用者削除は行えません。",
  "label.masterdata.biz_user_non_regist_user": "利用者登録されていないIDです。",
  "label.masterdata.biz_user_csv_diff_kaisha": "CSVファイル内に異なる会社の情報が設定されています。",
  "label.masterdata.biz_user_unusable_char": "使用できない{0}が入力されています。",
  "label.masterdata.biz_user_not_sub_organization": "{0}は利用者の所属組織より下位の組織管理者を設定することはできません。",
  "label.masterdata.biz_user_use_fw_kana": "{0}は全角カナ・全角スペースを使用してください。",
  "label.masterdata.biz_user_non_exist_base": "存在しない拠点番号が設定されています。",
  "label.masterdata.biz_user_valid_email_address": "{0}が正しいメールアドレスの形式ではありません。",
  "label.masterdata.biz_user_char_range": "{0}は{1}文字以上～{2}文字以内で入力してください。",
  "label.masterdata.biz_user_use_password_char": "{0}は半角英数字・記号（!#$%&*+-.:;=?@^_）を使用してください。",
  "label.masterdata.biz_user_password_policy": "{0}は半角英字大文字・半角英字小文字・半角数字が各1文字以上含まれている必要があります。",
  "label.masterdata.biz_user_already_exists": "入力した{0}は既に存在します。",
  "label.masterdata.biz_user_register_use_id_char": "半角英数字・記号（-=^_'{}'~@.）を使用してください。",
  "label.masterdata.biz_user_register_id_start_end_char": "先頭と末尾に記号（-~.）は使用できません。",
  "label.masterdata.biz_user_register_domain_use": "DWPで使用されているドメインを使用できません。",
  "label.masterdata.biz_user_register_not_sub_organization": "利用者の所属組織より下位の組織管理者を設定することはできません。",
  "label.masterdata.biz_user_register_use_fw_kana": "全角カナを使用してください。",
  "label.masterdata.biz_user_register_valid_email_address": "正しいメールアドレスの形式ではありません。",
  "label.masterdata.biz_user_register_char_range": "{0}文字以上～{1}文字以内で入力してください。",
  "label.masterdata.biz_user_register_use_password_char": "半角英数字・記号（!#$%&*+-.:;=?@^_）を使用してください。",
  "label.masterdata.biz_user_register_password_policy": "半角英字大文字・半角英字小文字・半角数字が各1文字以上含まれている必要があります。",
  "label.masterdata.biz_user_register_already_exists": "入力したIDは既に存在します。",
  "label.masterdata.biz_user_csv_upload_dialog_message": "新規登録／差分更新を実行します。よろしいですか？",
  "label.masterdata.biz_user_csv_upload_delete_dialog_message": "削除を実行します。よろしいですか？",
  "label.masterdata.biz_user_csv_upload_result_message": "以下の利用者を新規登録・差分更新しました。",
  "label.masterdata.biz_user_csv_upload_delete_result_message": "以下の利用者を削除しました。",
  "label.masterdata.biz_user_csv_upload_error_result_message": "CSVデータ不正により更新できませんでした。エラー一覧を確認し、修正したファイルを再度アップロードしてください。",
  "label.masterdata.biz_user_csv_upload_loading_message": "処理中です。画面はこのままでしばらくお待ちください。",
  "label.masterdata.biz_user_csv_upload_error_list": "エラー一覧",
  "label.masterdata.biz_user_csv_upload_registupload_list": "利用者新規登録／差分更新一覧",
  "label.masterdata.biz_user_csv_upload_delete_list": "利用者削除一覧",
  "label.masterdata.biz_user_csv_upload_return_upload": "アップロード画面へ戻る",
  "label.masterdata.biz_user_csv_file": "CSVファイル",
  "label.masterdata.biz_user_csv_file_select": "CSVファイル選択",
  "label.masterdata.biz_user_update_method": "更新方法",
  "label.masterdata.biz_user_line": "行",
  "label.masterdata.biz_user_error_content": "エラー内容",
  "label.masterdata.biz_user_id": "ID",
  "label.masterdata.biz_user_kaisha_soshiki": "会社／組織",
  "label.masterdata.biz_user_kaisha_soshiki_select": "会社／組織選択",
  "label.masterdata.biz_user_soshiki1": "1st組織コード",
  "label.masterdata.biz_user_soshiki2": "2nd組織コード",
  "label.masterdata.biz_user_soshiki3": "3rd組織コード",
  "label.masterdata.biz_user_soshiki4": "4th組織コード",
  "label.masterdata.biz_user_soshiki5": "5th組織コード",
  "label.masterdata.biz_user_soshiki6": "6th組織コード",
  "label.masterdata.biz_user_soshiki7": "7th組織コード",
  "label.masterdata.biz_user_soshiki8": "8th組織コード",
  "label.masterdata.biz_user_soshiki9": "9th組織コード",
  "label.masterdata.biz_user_soshiki10": "10th組織コード",
  "label.masterdata.biz_user_sei_mei": "姓名",
  "label.masterdata.biz_user_access_auth": "アクセス権限",
  "label.masterdata.biz_user_sei_ktkn": "カナ姓",
  "label.masterdata.biz_user_mei_ktkn": "カナ名",
  "label.masterdata.biz_user_sei_kanji": "姓",
  "label.masterdata.biz_user_mei_kanji": "名",
  "label.masterdata.biz_user_customer_cd": "ユーザ設定コード",
  "label.masterdata.biz_user_site_no": "拠点番号",
  "label.masterdata.biz_user_site": "拠点",
  "label.masterdata.biz_user_workplace_tdfk_cd": "勤務場所都道府県コード",
  "label.masterdata.biz_user_jusyo_tdfk_cd1": "自宅場所都道府県コード",
  "label.masterdata.biz_user_jusyo_tdfk_cd2": "その他滞在場所都道府県コード",
  "label.masterdata.biz_user_workplace_tdfk": "勤務場所都道府県",
  "label.masterdata.biz_user_jusyo_tdfk1": "自宅場所都道府県",
  "label.masterdata.biz_user_jusyo_tdfk2": "その他滞在場所都道府県",
  "label.masterdata.biz_user_mail_address1": "連絡先MAIL1",
  "label.masterdata.biz_user_mail_address2": "連絡先MAIL2",
  "label.masterdata.biz_user_mail_address3": "連絡先MAIL3",
  "label.masterdata.biz_user_web_auth_password": "パスワード",
  "label.masterdata.biz_user_new_web_auth_password": "新しいパスワード",
  "label.masterdata.biz_user_web_auth_password_generate": "パスワード生成",
  "label.masterdata.biz_user_upd_dt": "更新日時",
  "label.masterdata.biz_user_upd_dt_from": "更新日時（From）",
  "label.masterdata.biz_user_upd_dt_to": "更新日時（To）",
  "label.masterdata.biz_user_search_shain": "社員",
  "label.masterdata.biz_user_search_konai": "構内作業者",
  "label.masterdata.biz_user_search_zaisyokuchu": "在職中",
  "label.masterdata.biz_user_search_kyusyokuchu": "休職中",
  "label.masterdata.biz_user_register_title": "利用者登録",
  "label.masterdata.biz_user_register_result_title": "利用者登録結果",
  "label.masterdata.biz_user_search_title": "利用者検索",
  "label.masterdata.biz_user_search_detail_title": "利用者詳細",
  "label.masterdata.biz_user_search_update_title": "利用者更新",
  "label.masterdata.biz_user_search_update_result_title": "利用者更新結果",
  "label.masterdata.biz_user_search_delete_title": "利用者削除",
  "label.masterdata.biz_user_search_delete_result_title": "利用者削除結果",
  "label.masterdata.biz_user_search_csv_download": "検索結果をCSVファイル形式で出力",
  "label.masterdata.biz_user_search_kuuran": "　",
  "label.masterdata.biz_user_suppl": "利用者登録に関する補足事項",
  "label.masterdata.biz_user_suppl_read": "※必ずお読みください。",
  "label.masterdata.biz_user_id_help": "・メールアドレスを設定することを推奨しています<br />\n         ・40文字以下<br />\n         ・半角英字（大文字／小文字）・数字・記号（-=^_{}~@.）以外入力不可<br />",
  "label.masterdata.biz_user_ktkn_help": "全角カタカナ",
  "label.masterdata.biz_user_password_register_help": "・8~32文字以下<br />\n         ・半角英字大文字・半角英字小文字・半角数字を各1文字以上含む<br />\n         ・半角英字（大文字／小文字）・数字・記号（!#$%&*+-.:;=?@^_）以外入力不可<br />",
  "label.masterdata.biz_user_password_update_help": "・パスワードを変更する場合のみ入力してください<br />\n         ・8~32文字以下<br />\n         ・半角英字大文字・半角英字小文字・半角数字を各1文字以上含む<br />\n         ・半角英字（大文字／小文字）・数字・記号（!#$%&*+-.:;=?@^_）以外入力不可<br />",
  "label.masterdata.biz_user_csv_template_file": "テンプレートファイル",
  "label.masterdata.biz_user_manual": "利用者登録機能操作マニュアル",
  "label.masterdata.biz_user_csv_file1_help": "・CSVファイルのテンプレートファイルをダウンロード、または、利用者情報検索からCSVファイルをダウンロードし、アップロードするCSVファイルを作成してください。<br />",
  "label.masterdata.biz_user_csv_file2_help": "・利用者アップロード（CSV）の詳細については、以下のマニュアルを参照ください。<br />",
  "label.masterdata.biz_user_csv_file3_help": "・本機能で登録・更新・削除された利用者は、１日１回の夜間バッチでBiz安否確認／一斉通報サービスに連携されます。<br />\n           Biz安否確認／一斉通報サービスの利用者の登録状態を確認する場合は、翌日以降にBiz安否確認／一斉通報サービスにログインし、ご確認ください。<br />",
  "label.masterdata.biz_user_csv_file_hint": "・CSV形式（半角カンマ区切り）です。<br />\n         ・文字コードはUTF-8です。<br />\n         ・改行コードは0x0D0A（CR + LF）です。<br />\n         ・ファイルの拡張子は「.csv」です。<br />\n         ・CSVファイルの１行目は項目名として認識するため登録されません。<br />\n         ・CSVファイル中に入力チェックエラーの行が存在した場合は、CSVファイル中のすべてのデータの登録・更新・削除は行われません。<br />",
  "label.masterdata.biz_user_update_method_hint": "<span style=\"font-weight:bold\">新規登録／差分更新</span><br />\n         CSVファイルに存在するデータのみ上書きします。<br />\n         既に登録されている利用者は更新され、登録されていない利用者は新規登録されます。<br />\n         <br />\n         <span style=\"font-weight:bold\">削除</span><br />\n         CSVファイルに存在する利用者を削除します。",
  "label.masterdata.biz_user_search_method_help": "検索条件を入力し、検索ボタンを押してください。<br />\n         OneNEC事業継続支援システム内の機能から利用者登録されたBiz安否確認／一斉通報サービス利用者を検索できます。<br />\n         検索結果はCSVとしてダウンロードすることも可能です。",
  "label.masterdata.biz_user_register_manual_help": "利用者登録の詳細については、以下のマニュアルを参照ください。<br />",
  "label.masterdata.biz_user_search_manual_help": "利用者検索の詳細については、以下のマニュアルを参照ください。<br />",
  "label.usercustom.personal_register_input": "個人情報設定",
  "label.usercustom.personal_register_result": "個人情報設定結果",
  "label.usercustom.workplace_update_date": "勤務場所更新日時",
  "label.usercustom.homeplace_update_date": "自宅場所更新日時",
  "label.usercustom.otherplace_update_date": "その他滞在場所更新日時",
  "label.usercustom.group_search": "グループ検索",
  "label.usercustom.goutou_info": "<span style='font-weight: bold'>入力例</span><br/>玉川ルネッサンスシティN棟",
  "label.usercustom.floor_info": "階層を入力します。<br/><span style='font-weight: bold'>入力例</span><br/>3階：3<br/>中2階：M2<br/>地下1階：B1<br/>※中階はM、地階はBを使用します。",
  "label.usercustom.workspace_info": "<span style='font-weight: bold'>入力例</span><br/>西側",
  "label.usercustom.group_hisai": "NECグループ被災情報",
  "label.usercustom.display_target": "表示対象",
  "label.usercustom.group_damage_infomation_display_target": "NECグループ被災情報表示対象",
  "label.usercustom.list_searchs": "リストから探す",
  "label.usercustom.input_list": "リストにない拠点を入力する",
  "label.usercustom.site_other_nm_hint": "<span style='font-weight: bold'>入力例</span><br/>玉川プロジェクト",
  "label.usercustom.linkage_personal": "人事連携済み",
  "label.usercustom.linkage_personal_info": "（人事情報連携済み）",
  "label.usercustom.other_stay_place_hint": "出張などで、勤務場所・自宅場所と異なる都道府県に滞在している場合に設定してください。",
  "label.usercustom.update_date": "更新日時",
  "label.usercustom.mail_address_update_date": "メールアドレス更新日時",
  "label.usercustom.set_action_message": "以下の内容で設定しました。",
  "label.usercustom.linkage_master_data": "マスタ情報登録済み",
  "label.usercustom.linkage_master_data_info": "（マスタ情報登録済み）",
  "label.usercustom.mail_address_1": "メールアドレス１",
  "label.usercustom.mail_address_2": "メールアドレス２",
  "label.usercustom.mail_address_3": "メールアドレス３",
  "label.usercustom.usercustom_help": "設定した個人情報はBiz安否確認／一斉通報で以下の際に利用できます。<div style='font-weight: bold'>災害発生時やお知らせのPush通知</div>・勤務場所の都道府県<br/>・自宅場所の都道府県<br/>・その他滞在場所の都道府県<br/>・メールアドレス１、メールアドレス２、メールアドレス３<div style='font-weight: bold'>Biz安否確認／一斉通報のパスワードの再設定</div>・メールアドレス１、メールアドレス２、メールアドレス３<div style='font-weight: bold'>Biz安否確認／一斉通報の安否検索の検索条件（ロケーション）</div>・勤務場所の拠点<br/><br/>※人事連携されている勤務場所・自宅場所に変更がある場合、人事情報システムで変更してください。",
  "label.usercustom.workplace_help": "設定した勤務場所は以下の際に利用できます。<div style='font-weight: bold'>災害発生時やお知らせのPush通知</div>・都道府県<div style='font-weight: bold'>Biz安否確認／一斉通報の安否検索の検索条件（ロケーション）</div>・拠点",
  "label.usercustom.homeplace_help": "設定した自宅場所は以下の際に利用できます。<div style='font-weight: bold'>災害発生時やお知らせのPush通知</div>・都道府県",
  "label.usercustom.other_help": "設定したその他滞在場所は以下の際に利用できます。<div style='font-weight: bold'>災害発生時やお知らせのPush通知</div>・都道府県<br/>※出張等により勤務場所・自宅場所と異なる都道府県に滞在している場合に設定してください。",
  "label.usercustom.mail_address_help": "設定したメールアドレスは以下の場合に利用できます。<div style='font-weight: bold'>・災害発生時やお知らせのPush通知<br/>・Biz安否確認／一斉通報のパスワードの再設定</div>",
  "label.pande.report_title": "感染症報告",
  "label.pande.pande_search": "感染症検索",
  "label.pande.pande_totalize": "感染症集計",
  "label.pande.report_target_designation": "報告対象指定",
  "label.pande.report_no": "管理番号",
  "label.pande.nec_group": "（NECg）",
  "label.pande.report_target_input_fix": "報告対象入力確定",
  "label.pande.search_report_no": "管理番号で検索",
  "label.pande.select_from_list": "一覧から選択",
  "label.pande.select_report_target": "報告対象者選択",
  "label.pande.last_reporter": "前回報告者",
  "label.pande.last_reporter_kaisha_soshiki": "前回報告者会社／組織",
  "label.pande.last_report_date": "前回報告日時",
  "label.pande.report_target_change": "報告対象変更",
  "label.pande.report": "報告",
  "label.pande.confirming": "確認中",
  "label.pande.attribute": "属性",
  "label.pande.coop_kaisha_nm": "派遣元会社名／協力会社名",
  "label.pande.report_status": "報告対象者の状態",
  "label.pande.report_base_info": "基礎情報",
  "label.pande.customer_businessincharge": "担当顧客・業務",
  "label.pande.closecontact": "保健所からの濃厚接触者指定有無",
  "label.pande.closecontact_list": "濃厚接触者指定有無",
  "label.pande.closecontact_reason": "濃厚接触者に指定された理由",
  "label.pande.relation_report_no": "関連管理番号（necg）",
  "label.pande.shojo_umu": "症状有無",
  "label.pande.hassho_dt": "発症日",
  "label.pande.shussha": "発症２日前以降の出社",
  "label.pande.customer_contact": "発症２日前以降の顧客との接触",
  "label.pande.last_work_dt": "最終出社日",
  "label.pande.address": "住所（都道府県～市区町村まで）",
  "label.pande.age_sex": "年齢、性別",
  "label.pande.dokyo_kazoku": "同居家族有無",
  "label.pande.contact_entry": "本人との連絡可否（職場上司経由／協力会社経由）",
  "label.pande.shojo": "症状",
  "label.pande.shojo_history": "症状歴、今後の予定",
  "label.pande.kensa_rst": "検査結果",
  "label.pande.kensa_dt": "検査日",
  "label.pande.including_appointment": "（予定含む）",
  "label.pande.iryokikan": "診断した医療機関",
  "label.pande.kensa_rst_dt": "検査結果判明日",
  "label.pande.health_center": "対応保健所（市区町村まで）",
  "label.pande.treatments_policy": "治療方針",
  "label.pande.serious": "重症",
  "label.pande.treatments_end_dt": "療養終了日",
  "label.pande.death_dt": "死亡日",
  "label.pande.other": "他",
  "label.pande.hatsunetsusha": "職場内での発熱者有無",
  "label.pande.other_notes": "（フロア対応／同居家族検査実施状況など）",
  "label.pande.workstatus_entryplace": "勤務状況・立ち入り場所",
  "label.pande.umu": "有無",
  "label.pande.workstatus": "勤務の有無",
  "label.pande.necg_naigai": "NECg内外",
  "label.pande.entryplace": "立ち入り場所",
  "label.pande.building_name": "ビル名",
  "label.pande.cold_symptoms": "風邪症状",
  "label.pande.report_registration_full": "濃厚接触可能性者情報の報告登録",
  "label.pande.report_registration": "報告登録",
  "label.pande.contactperson": "NECg内の担当窓口",
  "label.pande.child": "関係会社内",
  "label.pande.nec": "NEC（営業等）",
  "label.pande.contact": "接触",
  "label.pande.last_contact_dt": "最終接触日",
  "label.pande.seat_spacing": "座席間隔",
  "label.pande.talk": "会話",
  "label.pande.contact_time": "接触時間",
  "label.pande.mask_chakuyo": "接触時のマスク着用",
  "label.pande.report_target_user": "報告対象者",
  "label.pande.close_contact": "接触者",
  "label.pande.closecontact_necg": "濃厚接触可能性者情報（NECg社員）",
  "label.pande.closecontact_other": "濃厚接触可能性者情報（派遣・請負）",
  "label.pande.closecontact_customer": "濃厚接触可能性者情報（顧客）",
  "label.pande.closecontact_necg_item": "濃厚接触可能性者（NECg社員）",
  "label.pande.closecontact_other_item": "濃厚接触可能性者（派遣・請負）",
  "label.pande.closecontact_customer_item": "濃厚接触可能性者（顧客）",
  "label.pande.branch_nm": "事務所・店舗等",
  "label.pande.affiliation": "所属",
  "label.pande.contactperson_eigyo": "顧客窓口（営業等）",
  "label.pande.reporter_bcc": "報告者・同報先情報",
  "label.pande.mail_send": "メール送信",
  "label.pande.mail_send_ari": "有り",
  "label.pande.sheet_map": "座席表",
  "label.pande.sheat_map_1m": "（感染疑い者から半径1m以内を明示）",
  "label.pande.wantto_check": "確認したい情報",
  "label.pande.report_no_necg": "管理番号（necg）",
  "label.pande.situation": "報告状況",
  "label.pande.first_report_dt": "初回報告日",
  "label.pande.end_report_dt": "最終報告日",
  "label.pande.end_report_dt_progress": "最終報告日（遅延アラート）",
  "label.pande.confirming_items": "確認中項目",
  "label.pande.lator": "以降",
  "label.pande.tot_closecontact": "濃厚接触者指定",
  "label.pande.tot_kansen": "感染（疑い）者",
  "label.pande.report_target_type_new": "新しい報告を登録する",
  "label.pande.report_target_type_followup": "登録済みの報告を修正する（続報の登録もこちら）",
  "label.pande.report_target_person_select": "選択する",
  "label.pande.report_target_person_input": "入力する",
  "label.pande.report_supplement_matter": "感染症報告入力についての補足事項",
  "label.pande.invariably_read": "※必ずお読みください。",
  "label.pande.age_suffix": "歳",
  "label.pande.place_entry_dt": "年月日",
  "label.pande.report_registered": "済み",
  "label.pande.closecontact_cold_symptoms": "現時点での発熱などの風邪症状",
  "label.pande.closecontact_potential_info": "濃厚接触可能性者情報",
  "label.pande.closecontact_kanousei": "濃厚接触可能性者（保健所からの指定なし、または調査中はこちらへ）",
  "label.pande.closecontact_shitei": "濃厚接触者（保健所から指定を受けた場合はこちらへ）",
  "label.pande.put_on_mask": "マスク着用",
  "label.pande.ninzu": "人数",
  "label.pande.closecontact_potential_person": "濃厚接触可能性者",
  "label.pande.closecontact_person": "濃厚接触者",
  "label.pande.customer_nm": "顧客名",
  "label.pande.reporter": "報告者",
  "label.pande.first_reporter_nm": "初回報告者姓名",
  "label.pande.first_reporter_kaisha_nm": "初回報告者会社名",
  "label.pande.first_reporter_soshiki_nm": "初回報告者組織名",
  "label.pande.last_report_date_time": "最終報告日時",
  "label.pande.quote_previously": "前回登録内容を引用",
  "label.pande.confirm_before_move": "変更した内容が破棄されます。よろしいですか？<br/>キャンセルを押すと元の画面に戻ります。",
  "label.pande.report_does_not_exist": "管理番号が間違っているか、管理番号の報告内容を検索できる権限がありません。",
  "label.pande.mail_send_section": "宛先",
  "label.pande.required_list_message": "{0}を追加してください。",
  "label.pande.kaisha_soshiki": "会社／組織",
  "label.pande.all": "全て",
  "label.pande.report_list": "管理表",
  "label.pande.progress": "報告遅延アラート",
  "label.pande.work_place": "勤務場所",
  "label.pande.work_place_site": "勤務場所－拠点",
  "label.pande.work_place_goutou": "勤務場所－号棟",
  "label.pande.work_place_floor": "勤務場所－階",
  "label.pande.work_place_workspace": "勤務場所－フロア",
  "label.pande.work_place_select": "勤務場所選択",
  "label.pande.list_selection": "リストから選択する",
  "label.pande.enter_site": "リストにない拠点を入力する",
  "label.pande.company": "会社",
  "label.pande.company_name": "会社名",
  "label.pande.tdfk": "都道府県",
  "label.pande.site": "拠点",
  "label.pande.report_to_customer": "顧客への検査結果未報告",
  "label.pande.shodoku": "消毒",
  "label.pande.file_delete_failed": "ファイルの削除が失敗しました。",
  "label.pande.include_rel_reportNo": "関連する管理番号を含む",
  "label.pande.report_search_by_no": "管理番号で検索",
  "label.pande.report_search_list": "一覧から検索",
  "label.pande.report_target_select": "報告対象者選択",
  "label.pande.input_detail": "・詳細に入力する",
  "label.pande.input_simple": "・人数のみ入力する",
  "label.pande.rel_count": "濃厚接触者数",
  "label.pande.required_closecontact_message": "「詳細に入力する」「人数のみ入力する」のいずれかを入力してください。",
  "label.pande.mail_to_section_message": "TOは必ず一つ以上設定してください。",
  "label.pande.report_register_fail_message": "感染症報告情報の登録に失敗しました。",
  "label.pande.report_target_seimei": "報告対象者姓名",
  "label.pande.report_target_kaisha_soshiki": "報告対象者会社／組織",
  "label.pande.report_target_kaisha_soshiki_detail": "（派遣／請負の場合は発注元のNECグループの会社／組織）",
  "label.pande.report_target_kaisha": "報告対象者会社名",
  "label.pande.report_target_soshiki": "報告対象者組織名",
  "label.pande.report_target_kaisha_detail": "（派遣／請負の場合は発注元のNECグループの会社）",
  "label.pande.report_target_soshiki_detail": "（派遣／請負の場合は発注元のNECグループの組織）",
  "label.pande.all_site_on_the_list": "リストにある拠点全て",
  "label.pande.all_site_not_on_the_list": "リストにない拠点全て",
  "label.pande.report_register_confirm_message": "この内容で報告します。よろしいですか？<br/>\n    メールが送信されますので、宛先に誤りがないか確認してください。\n    <div>\n    {0}\n    </div>\n    {1}",
  "label.pande.report_update_confirm_message": "管理番号：{2}をこの内容で上書き更新します。<br/>よろしいですか？<br/>\n    メールが送信されますので、宛先に誤りがないか確認してください。\n    <div>\n    {0}\n    </div>\n    {1}",
  "label.pande.report_close_message": "{0}のため、当報告をクローズします。後続の報告は不要です。",
  "label.pande.report_close_message_serious": "当報告をクローズします。<br/>個別にヒアリングさせて頂きたく、これから届くメールをご確認ください。",
  "label.pande.report_close_reason_treatments_end": "療養終了",
  "label.pande.report_close_reason_health_observation_end": "健康観察終了",
  "label.pande.report_close_reason_test_negative": "検査結果陰性",
  "label.pande.report_detail": "感染症詳細",
  "label.pande.report_close_reason_serious_end": "死亡",
  "label.pande.hassho_dt_entry": "発症日（発熱などの風邪の諸症状が出た初日）",
  "label.pande.closecontact_required_ninzu_message": "必ずいずれかの人数を設定してください。",
  "label.pande.kensa_rst_report_cd": "お客様への検査結果報告",
  "label.pande.kensa_rst_report_cd_rk": "検査結果報告",
  "label.pande.kensa_rst_reported": "済み",
  "label.pande.report_target_user_rk": "本人",
  "label.pande.report_update": "感染症更新",
  "label.pande.no_site_list": "選択された都道府県・会社に一致する拠点情報はありません。",
  "label.pande.no_area_list": "選択された会社に一致する地域情報はありません。",
  "label.pande.no_area_site_list": "選択された地域に一致する拠点情報はありません。",
  "label.pande.include_suspicious": "保健所からの濃厚接触者指定有無が「確認中」を含む",
  "label.pande.include_suspicious_hint": "スイッチがON（右）の場合、保健所からの濃厚接触者指定有無が「確認中」で登録された報告を「濃厚接触者」の集計結果に含みます。<br/>集計結果から除外する場合、スイッチをOFF（左）にしてください。",
  "label.pande.not_set_mailaddress": "設定されていません",
  "label.pande.search_help": "確認したい情報を選択して検索条件を入力し、検索ボタンを押してください。<br/>感染症情報は機微な情報となるため閲覧に制限をかけております。<br/>感染症検索・集計機能の利用権限を特別に付与されている方のみ利用可能です。",
  "label.pande.search_include_rel_report_no_hint": "指定した管理番号の報告に加えて、該当の管理番号を関連管理番号として登録している方の報告も検索します。<br/>\n    ※関連管理番号とは、保健所から濃厚接触者に指定される起因となった感染症報告の管理番号を示します。",
  "label.pande.search_report_result_help": "<b>濃厚接触者数</b>：保健所から濃厚接触者指定された方が、該当の管理番号の報告との関連付けをして登録した数",
  "label.pande.search_progress_result_help": " <b>確認中項目 </b>：内容調査中などで必須項目を未入力のままの項目が存在する場合に背景色を赤色で表示します。<br/>\n    <b>顧客への検査結果未報告</b>：顧客が濃厚接触可能性者に該当する際に、検査結果を顧客に未報告のままである場合に背景色を赤色で表示します。<br/>\n    <b>最終報告日</b>：最後の報告日から一定以上経過し、情報の更新を行っていない場合に背景色を赤色で表示します。<br/>",
  "label.pande.report_title_help": "報告対象者からヒアリングした情報を入力し、「報告」ボタンを押してください。",
  "label.pande.report_supplement_matter_hint": "風邪などの諸症状があり、感染症の疑いのため検査実施が決定した場合は報告登録を行ってください。<br/>また、保健所などにより、濃厚接触者と指定された場合も報告登録を行ってください。",
  "label.pande.report_target_seimei_hint": "感染者、濃厚接触者の方の姓名を入力してください。",
  "label.pande.report_target_kaisha_soshiki_hint": "以下の会社／組織を選択または入力してください。<br/>　NECグループ社員の場合：所属する会社／組織<br/>　派遣／請負の場合：発注元のNECグループの会社／組織<br/><br/><span style=\"font-weight:bold\">選択する</span><br/>リストボックスに報告対象者の所属するNECg内の会社／組織が存在する場合に選択してください。<br/><span style=\"font-weight:bold\">入力する</span><br/>リストボックスに会社／組織が存在しない場合に選択し、手入力で会社名や組織名を入力してください。",
  "label.pande.report_target_soshiki_hint": "<span style=\"font-weight:bold\">入力例</span><br/>営業部／第一営業課／第二営業グループ",
  "label.pande.report_no_necg_hint": "初回報告登録時に採番されたnecgの後に続く数字を入力してください。<br/>（自動応答メールの件名にも設定されています）",
  "label.pande.enter_site_hint": "リストにない拠点を選択した場合、拠点名を入力してください。",
  "label.pande.closecontact_hint": "報告対象者が保健所から濃厚接触者として指定を受けた場合、「有り」を選択してください。<br/>\n    ※同居家族陽性時に保健所による濃厚接触者調査が遅延する際は、報告対象者を濃厚接触者とみなして「有り」を選択してください。",
  "label.pande.closecontact_reason_hint": "２日前に会議を行っていた方の中から陽性者が出た、<br/>同居家族が陽性と診断された、など<br/>保健所から指定される起因として提示された事象を入力してください。",
  "label.pande.relation_report_no_hint": "すでに報告登録済みのNECg社員または派遣・請負の方の<br/>濃厚接触者に指定された場合は、管理番号を入力してください。",
  "label.pande.hassho_dt_hint": "くしゃみや咳などの軽い症状を含め、症状が出た初日を入力してください。<br/>また、保健所から発症日が指定された場合は、指定された日に変更してください。",
  "label.pande.shojo_history_hint": "風邪の諸症状が出てからの症状歴や、医療機関受診時に<br/>指示された今後の予定などを入力してください。<br/>\n    <span style=\"font-weight:bold\">入力例</span><br/>\n    9/2　　　症状は無し　通常通り出社<br/>\n    9/3早朝　頭痛があり薬を飲む　休暇<br/>\n    9/3夕方　受診　37.5度発熱、倦怠感あり<br/>\n    　　　　&nbsp;&nbsp;抗原検査実施（結果陰性）<br/>\n    9/4　　　PCR検査実施<br/>\n    9/6　　　検査結果判明予定　倦怠感は継続<br/>",
  "label.pande.shojo_serious_hint": "初期値はOFF（重症ではない）となっています。<br/> 重症（ICUに入室もしくは人工呼吸器が必要な状態）の場合はスイッチをONにしてください。",
  "label.pande.workstatus_entryplace_help": "発症２日前以降の行動履歴を入力してください。",
  "label.pande.dialog_closecontact_hint": "濃厚接触可能性者が保健所から濃厚接触者として指定を受けた場合、「有り」を選択してください。",
  "label.pande.report_registration_hint": "濃厚接触者として指定された方、検査を受け陽性だった方は別途感染症報告の登録を行ってください。<br/>報告の登録が完了後、スイッチをON（右）にしてください。",
  "label.pande.contact_time_hint": "<span style=\"font-weight:bold\">入力例</span><br/>10時間の場合、10:00（HH:mm）",
  "label.pande.kensa_rst_report_cd_hint": "報告対象者の検査結果は必ず顧客へ報告してください。<br/>報告が完了しましたら、スイッチをON（右）にしてください。",
  "label.pande.reporter_bcc_help": "・感染症情報は機微な情報となるため閲覧の範囲に制限をかけております。<br/>　報告内容が記載された自動応答メールを受信しても問題のない方や、<br/>　今後の続報登録を行えて問題のない方をこちらから設定してください。<br/>　一覧の報告者・同報先名欄に名前がある方は続報登録を行えます。<br/><br/>・同報先保存ボタンで一覧に表示されている報告者・同報先情報に<br/>　任意の名称をつけて保存できます。<br/><br/>・同報先引用ボタンは保存した報告者・同報先情報の選択、削除ができます。<br/>　選択した場合、一覧に報告者・同報先情報を追加します。<br/>　情報が重複している場合は、先に設定されている情報が優先されます。<br/>　（メール送信、宛先）<br/><br/>・同報先引用、同報先保存は初回報告時のみ利用可能です。",
  "label.pande.mail_send_hint": "今後の続報登録を行う可能性があるが、自動応答メールの受信が不要な場合はスイッチをOFF（左）にしてください。",
  "label.pande.mail_address_hint": "MLアドレス追加で以下のいずれかのメールアドレスを入力できます。<br/>・NECグループの国内ドメインのメールアドレス<br/>・社有携帯のキャリアメールアドレス<br/>　※規定されているキャリアメールのアドレスルールに<br/>　　即しているもの",
  "label.pande.mail_send_section_hint": "自動応答メールの宛先の種別を選択してください。<br/>TOは必ず一人以上設定してください。",
  "label.pande.sheat_map_1m_hint": "報告対象者の座席から半径１ｍ以内の座席表を添付してください。<br/>報告対象者の座席がわかるようにしてください。",
  "label.pande.sheat_map_mask_hint": "消毒業者に提出する際に個人情報が表示されていない座席表を提示するため、個人情報を削除した座席表を添付してください。<br/>報告対象者の座席がわかるようにしてください。",
  "label.pande.pande_totalize_help": "感染症情報は機微な情報となるため閲覧に制限をかけております。<br/>感染症検索・集計機能の利用権限を特別に付与されている方のみ利用可能です。",
  "label.pande.report_new_report_no": "（登録後に採番されます）",
  "label.pande.report_register_result": "感染症報告登録結果",
  "label.pande.report_registered_message": "管理番号{0}を登録しました。",
  "label.pande.report_updated_message": "管理番号{0}を更新しました。",
  "label.pande.report_deleted_message": "管理番号{0}を削除しました。",
  "label.pande.numericality_message": "数字で入力してください。",
  "label.pande.numericality_single_byte_message": "半角数字で入力してください。",
  "label.pande.loading_report_message": "情報取得中...",
  "label.pande.pande.data_not_found_message": "報告情報が削除されたため表示できませんでした。",
  "label.pande.last_information_registrant": "最終報告者姓名",
  "label.pande.report_status_hint": "検査実施決定：検査を受けることが決まった、または受けた<br/>\n    濃厚接触者指定：保健所から濃厚接触者に指定された<br/>\n    検査結果判明：検査結果の通知を受けた<br/>\n    療養内容報告：検査結果陽性で、治療方針が決定した<br/>\n    療養終了：医師の判断で療養終了し、出社可能となった（陽性者）<br/>\n    健康観察終了：健康観察終了し、出社可能となった（濃厚接触者）<br/>\n    死亡：新型コロナウイルスを原因として亡くなった",
  "label.pande.broadcast": "報告者・同報先",
  "label.pande.broadcast_nm": "報告者・同報先名",
  "label.pande.broadcast_save_register_fail_message": "同報先情報保存の登録に失敗しました。",
  "label.pande.broadcast_quote_btn": "引用",
  "label.pande.broadcast_save_register_result": "保存しました。",
  "label.pande.broadcast_save_delete_confirm": "削除します。よろしいですか？",
  "label.pande.broadcast_save_delete_result": "削除しました。",
  "label.pande.ml_address_add": "MLアドレス追加",
  "label.pande.duplicate_mail_address_message": "重複しています。",
  "label.pande.invalid_mail_address_message": "許可されているアドレスを入力してください。",
  "label.pande.include_blank_mail_address_message": "アドレスに空白が含まれています。",
  "label.pande.broadcast_add": "同報先",
  "label.pande.shojo_history_supplement": "（症状がある場合は、発症２日前以降の症状歴、立ち寄り場所等を記入）",
  "label.pande.mail_template": "メールテンプレート設定",
  "label.pande.mail_template_update": "メールテンプレート更新",
  "label.pande.mail_template_update_result": "メールテンプレート更新結果",
  "label.pande.mail_text": "メール本文",
  "label.pande.mail_template_help": "メールテンプレートの更新を行う場合は、テンプレート一覧の <svg class=\"MuiSvgIcon-root-701\" focusable=\"false\" viewBox=\"0 0 24 24\" width=\"24\" height = \"24\" aria-hidden=\"true\" role=\"presentation\"><path d=\"M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z\"></path></svg> を押してください。<br/>\n    一覧にて「－(ハイフン)」の項目はテンプレート判定条件に含まれません。",
  "label.pande.template_no": "テンプレート番号",
  "label.pande.shussha_cd": "発症2日目以降の出社有無",
  "label.pande.closecontact_umu_cd": "濃厚接触可能性者有無",
  "label.pande.disp_upd_dt": "最終更新日時",
  "label.pande.mail_template_template_no_98_help": "検査結果が「陽性」以外、かつ感染症情報の続報登録・更新時にテンプレート判定条件となる項目の設定値が変更されていない場合",
  "label.pande.mail_template_template_no_99_help": "検査結果が「陽性」、かつ感染症情報の続報登録・更新時にテンプレート判定条件となる項目の設定値が変更されていない場合",
  "label.pande.mail_template_closecontact_help": "<span style=\"font-weight:bold\">確認中／無し</span><br/>\n    　保健所からの濃厚接触者指定有無が「無し」<br/>\n    　または「確認中」の場合<br/>\n    <span style=\"font-weight:bold\">有り</span><br/>\n    　保健所からの濃厚接触者指定有無が「有り」の場合",
  "label.pande.mail_template_closecontact_umu_help": "<span style=\"font-weight:bold\">無しのみ</span><br/>\n    　対象項目全てが「無し」の場合<br/>\n    <span style=\"font-weight:bold\">確認中／有りが一つ以上</span><br/>\n    　対象項目のいずれか一つでも「確認中」<br/>\n    　または「有り」の場合<br/>\n    【濃厚接触可能性有無　対象項目】<br/>\n    　・濃厚接触可能性者（NECg社員）有無<br/>\n    　・濃厚接触可能性者（派遣・請負）有無<br/>\n    　・濃厚接触可能性者（顧客）有無",
  "label.pande.return_to_mail_template": "一覧へ戻る",
  "label.pande.mail_template_send_condition": "メールテンプレート情報",
  "label.pande.mail_template_mail_text": "本機能では以下に記載した内容を除く、メール本文中でテンプレートごとに異なる箇所の編集を可能とします。<br/>\n    　・宛先（TO）、メール冒頭の定型文<br/>\n    　・URLなどの定型文<br/>\n    　・メール末尾の画面入力された設定値<br/>",
  "label.pande.mail_template_result_mail_image": "実際に送信されるメール全体イメージです。",
  "label.pande.mail_template_result_valiable": "更新可能箇所は背景色青色、それ以外の箇所は固定文言（変更不可）です。",
  "label.pande.broadcast_quote": "同報先引用",
  "label.pande.broadcast_quote_title": "報告者・同報先引用",
  "label.pande.broadcast_save": "同報先保存",
  "label.pande.broadcast_save_title": "報告者・同報先保存",
  "label.pande.broadcast_save_nm": "報告者・同報先保存名",
  "label.pande.broadcast_nm_saved_confirm_massage": "保存します。よろしいですか？",
  "label.pande.broadcast_nm_update_confirm_message": "「{0}」を上書き保存します。よろしいですか？",
  "label.pande.broadcast_no_data_message": "報告者・同報先が保存されていません。",
  "label.pande.no_shain_message": "{0}の情報が存在しないため引用できませんでした。",
  "label.pande.privacy_policy": "個人情報取扱い方針兼同意書",
  "label.pande.no_save_list_message": "報告者・同報先情報が設定されていません。",
  "label.pande.authorize_setting": "感染症利用権限設定",
  "label.pande.authorize_setting_help": "設定を更新する場合は検索結果一覧の\n    <svg class=\"MuiSvgIcon-root-701\" focusable=\"false\" viewBox=\"0 0 24 24\" width=\"24\" height = \"24\" aria-hidden=\"true\" role=\"presentation\">\n    <path d=\"M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z\" />\n    </svg> を押してください。",
  "label.pande.authorize": "感染症利用権限",
  "label.pande.authorize_hint": "指定した感染症利用権限が設定されている方を検索します。",
  "label.pande.update_yohi": "更新・詳細参照要否",
  "label.pande.no_authorize": "利用権限未設定",
  "label.pande.authorize_clear_hint": "一括で設定を解除できます。<br/>\n    複数の会社の権限が設定されている方については更新画面で個別に削除してください。",
  "label.pande.authorize_clear_confirm_message": "感染症利用権限をクリアし、未設定の状態にします。よろしいですか？",
  "label.pande.authorize_update": "感染症利用権限更新",
  "label.pande.authorize_update_result": "感染症利用権限更新結果",
  "label.pande.authorize_mail_yohi": "メール受信要否",
  "label.pande.authorize_update_help": "感染症情報の検索・集計、および報告時の同報メール受信の権限を付与します。<br/>\n    付与する権限、権限に応じた会社・組織・拠点・都道府県、メール受信要否などの指定を行ってください。",
  "label.pande.authorize_update_yohi_hint": "機微情報を含む個人情報が表示される画面を参照・更新可能とするかどうかを指定してください。<br/>\n    （個人情報を取り扱うことになりますので、設定は慎重にお願いいたします）",
  "label.pande.authorize_select_hint": "<span style=\"font-weight:bold\">全社</span><br/>\n    全社の全ての報告内容を検索可能となります。<br/>\n    <span style=\"font-weight:bold\">会社指定</span><br/>\n    複数指定可能です。<br/>\n    <span style=\"font-weight:bold\">会社／組織指定</span><br/>\n    複数指定可能です。<br/>\n    指定した組織配下を含む組織が対象となります。<br/>\n    <span style=\"font-weight:bold\">拠点指定</span><br/>\n    複数指定可能です。<br/>\n    <span style=\"font-weight:bold\">都道府県指定</span><br/>\n    複数指定可能です。",
  "label.pande.mail_yohi_hint": "権限区分の条件に一致する感染症報告の登録時にメールを同報する場合、スイッチをON（右）にしてください",
  "label.pande.authorize_changeable_hint": "権限によっては、ご自身が所属する会社（及び所属する組織、所属する拠点）のみ設定・変更・削除可能です。",
  "label.pande.all_delete": "全て削除",
  "label.pande.duplicate_authorize_message": "重複しています。",
  "label.pande.entryplace_building_nm_1": "立ち入り場所１－ビル名",
  "label.pande.entryplace_goutou_1": "立ち入り場所１－号棟",
  "label.pande.entryplace_floor_1": "立ち入り場所１－階",
  "label.pande.entryplace_workspace_1": "立ち入り場所１－フロア",
  "label.pande.entryplace_building_nm_2": "立ち入り場所２－ビル名",
  "label.pande.entryplace_goutou_2": "立ち入り場所２－号棟",
  "label.pande.entryplace_floor_2": "立ち入り場所２－階",
  "label.pande.entryplace_workspace_2": "立ち入り場所２－フロア",
  "label.pande.age": "年齢",
  "label.pande.sex": "性別",
  "label.pande.detail": "明細",
  "label.grouphisai.grouphisai_registration": "NECグループ被災情報登録",
  "label.grouphisai.grouphisai_search": "NECグループ被災情報検索",
  "label.grouphisai.grouphisai_sort": "NECグループ被災情報振り分け",
  "label.grouphisai.grouphisai_detail": "NECグループ被災情報詳細",
  "label.grouphisai.grouphisai_history": "NECグループ被災情報履歴",
  "label.grouphisai.grouphisai_update": "NECグループ被災情報更新",
  "label.grouphisai.grouphisai_update_result": "NECグループ被災情報更新結果",
  "label.grouphisai.grouphisai_delete": "NECグループ被災情報削除",
  "label.grouphisai.grouphisai_delete_result": "NECグループ被災情報削除結果",
  "label.grouphisai.grouphisai_sort_detail": "NECグループ被災情報振り分け詳細",
  "label.grouphisai.grouphisai_sort_delete": "NECグループ被災情報振り分け削除",
  "label.grouphisai.grouphisai_sort_delete_result": "NECグループ被災情報振り分け削除結果",
  "label.grouphisai.grouphisai_sort_set_source": "NECグループ被災情報振り分け掲載先設定",
  "label.grouphisai.grouphisai_sort_set_source_result": "NECグループ被災情報振り分け掲載先設定結果",
  "label.grouphisai.subject": "件名",
  "label.grouphisai.last_updated_name": "最終更新者",
  "label.grouphisai.mail_capture": "メール取込(システム自動)",
  "label.grouphisai.last_updated_date": "最終更新日時",
  "label.grouphisai.attached_file": "添付ファイル",
  "label.grouphisai.no_attached_file": "添付ファイルはありません。",
  "label.grouphisai.no_info_message": "検索条件に該当するNECグループ被災情報はありません。",
  "label.grouphisai.select_target": "登録対象選択",
  "label.grouphisai.make_mail": "メール作成",
  "label.grouphisai.grouphisai_registration_help": "登録対象を選択し、メール作成ボタンを押すとメーラーが起動します。<br/>\n    ※起動するメーラーは端末の設定に依存します。<br/>\n    使用したいメーラーが起動しなかった場合は、以下の手順でメールに対する既定のアプリの設定を行ってください。<br/><br/>\n    ①「スタートメニュー」から「設定アイコン」をクリックし、Windowsの設定画面を開きます。<br/>\n    ②Windowsの設定画面で「アプリ」をクリックし、左ペインで「規定のアプリ」をクリックします。<br/>\n    ③既定のアプリの選択画面で、「メール」のアイコンをクリックし、使用したいメーラー（Outlook推奨）を選択します。<br/>\n    メーラー起動後は宛先と内容を入力し、メールを送信してください。<br/>\n    <br/>\n    <b>システムでメーラーに自動設定する内容</b><br/>\n    ・CC：システムのメールアドレスを設定します。追加の送信先がある場合は追加してください。<br/>\n    　（※システムで自動設定したメールアドレスを削除しないようにしてください）<br/>\n    ・件名：本画面で選択した情報に応じて、件名を設定します。<br/>\n    　件名に追加で記載したい内容がある場合は、システムで自動設定した内容の後ろに記載をしてください。<br/>\n    　（※システムで自動設定した件名を変更しないようにしてください）<br/>\n    ・本文：入力項目のテンプレートを設定します。登録したい内容を記載してください。<br/>\n    　（※テンプレートの構成を変更しても問題ありません）<br/>\n    <br/>\n    <b>入力項目説明</b><br/>\n    ・概況：発生した災害の概要や被害状況などに関する情報<br/>\n    ・従業員被災状況：負傷者／行方不明者／死者に関する情報<br/>\n    ・会社インフラ被災状況：建物／電気・ガス・水道／システム／通信に関する情報<br/>\n    ・開発・生産被災状況：開発・生産ライン／顧客／サプライヤーに関する情報",
  "label.grouphisai.post_cannot_set_message": "この掲載先は設定できません。",
  "label.grouphisai.mail_template": "＜概況＞%0D%0A%0D%0A＜被災状況＞%0D%0A〇従業員%0D%0A　死者：%0D%0A　負傷者：%0D%0A　行方不明者：%0D%0A%0D%0A〇会社インフラ%0D%0A　建屋：%0D%0A　電気：%0D%0A　ガス：%0D%0A　水道：%0D%0A　システム：%0D%0A%0D%0A〇開発・生産%0D%0A　開発・生産ライン：%0D%0A　顧客への影響：%0D%0A　協力会社・サプライヤー：%0D%0A%0D%0A〇その他%0D%0A%0D%0A",
  "label.grouphisai.set_action_message": "以下の内容で設定しました。",
  "label.notice.notice_title": "メンテナンス情報",
  "label.notice.notification_register": "メンテナンス情報登録",
  "label.notice.result": "メンテナンス情報登録結果",
  "label.notice.detail": "メンテナンス情報詳細",
  "label.notice.detail_help": "Biz安否確認／一斉通報に関するメンテナンス情報は、Biz安否確認／一斉通報＞メンテナンスを参照してください。",
  "label.notice.notice_update": "メンテナンス情報更新",
  "label.notice.notice_update_result": "メンテナンス情報更新結果",
  "label.notice.last_notice_quote": "前回のメンテナンス情報引用",
  "label.notice.citation.confirm_message": "前回登録したお知らせを引用しますか？<br/>（今の表示内容は上書きされます。）",
  "label.notice.notification_history": "メンテナンス情報履歴",
  "label.notice.no_notification_registered": "前回登録したお知らせがありません。",
  "label.kansa.kansa_unavailability": "利用できる監査対象事業がありません。",
  "label.kansa.kansa_answer_register": "監査回答登録",
  "label.kansa.kansa_answer_show": "監査回答表示",
  "label.kansa.kansa_answer_result": "監査回答結果",
  "label.kansa.kansa_answer": "監査回答",
  "label.kansa.bcp_development_trail_added": "BCP策定証跡追加",
  "label.kansa.trail_register": "証跡登録",
  "label.kansa.trail_update": "証跡変更",
  "label.kansa.kansa_bumon": "監査部門",
  "label.kansa.kansa_bumon_select": "監査部門選択",
  "label.kansa.hi_kansa_bumon": "被監査部門",
  "label.kansa.hi_kansa_bumon_select": "被監査部門選択",
  "label.kansa.nendo": "年度",
  "label.kansa.trail": "証跡",
  "label.kansa.trail_name": "証跡名",
  "label.kansa.trail_added": "証跡追加",
  "label.kansa.file": "ファイル",
  "label.kansa.file_select": "ファイル選択",
  "label.kansa.unanswered": "未回答",
  "label.kansa.answering": "回答中",
  "label.kansa.answered": "回答済",
  "label.kansa.inserted": "登録済",
  "label.kansa.gyomu_content": "業務内容",
  "label.kansa.audit_year": "監査対象年度",
  "label.kansa.reference_value": "参考値：",
  "label.kansa.result_value": "結果：",
  "label.kansa.audit_theme": "監査テーマ",
  "label.kansa.audit_business": "監査対象事業",
  "label.kansa.audit_answer_status": "監査回答状況",
  "label.kansa.audit_only_business_show": "担当の監査対象事業のみ表示",
  "label.kansa.kansa_sekininsha": "監査部門責任者",
  "label.kansa.hikansa_sekininsha": "被監査部門責任者",
  "label.kansa.shiteki_kaizen": "指摘事項改善",
  "label.kansa.shiteki_jiko": "指摘事項",
  "label.kansa.making_status": "作成状況",
  "label.kansa.improvement_plan_status": "計画状況",
  "label.kansa.progress_status": "進捗状況",
  "label.kansa.evaluation_status": "評価状況",
  "label.kansa.chief_hyoka": "被監査部門責任者評価",
  "label.kansa.shiteki_kaizenplan_zisseki_register": "指摘事項改善計画・実績登録",
  "label.kansa.shiteki_kaizenplan_zisseki_result": "指摘事項改善計画・実績登録結果",
  "label.kansa.shiteki_kaizenplan_zisseki_display": "指摘事項改善計画・実績表示",
  "label.kansa.no_shiteki_kaizenplan_zisseki": "該当する指摘事項改善計画・実績がありません。",
  "label.kansa.shiteki_jiko_kbn": "指摘事項区分",
  "label.kansa.shiteki_sho_title": "ISO22301章タイトル",
  "label.kansa.shiteki_yokyu_jiko": "ISO22301要求事項",
  "label.kansa.shiteki_hakken_jiko_bunrui": "発見事項分類",
  "label.kansa.shiteki_hakken_jiko": "発見事項",
  "label.kansa.shiteki_kakunin_jiko": "確認事項",
  "label.kansa.shiteki_kakunin_kekka": "確認結果",
  "label.kansa.shiteki_kakunin_hosoku": "確認補足",
  "label.kansa.shiteki_taisaku": "対策",
  "label.kansa.shiteki_tantosha": "担当者",
  "label.kansa.shiteki_plan_sakuteiji": "計画策定時",
  "label.kansa.shiteki_comp_yotei_date": "完了予定日",
  "label.kansa.shiteki_shonin_date": "承認日",
  "label.kansa.shiteki_shoninsha": "承認者",
  "label.kansa.shiteki_taio_comp": "対応完了時",
  "label.kansa.shiteki_comp_date": "完了日",
  "label.kansa.shiteki_kakusho_exm": "【確証例】",
  "label.kansa.no_future": "{0}の{1}に未来日は入力できません。",
  "label.kansa.lastyear_kansa_answer_show": "前年度の監査回答を表示",
  "label.kansa.bcp_development_of_trail_added": "BCP策定の証跡を追加",
  "label.kansa.bcp_target_business": "BCP対象事業",
  "label.kansa.document_nm": "ドキュメント名",
  "label.kansa.bcp_terget_select": "追加対象選択",
  "label.kansa.answered_temporarily_store": "回答一時保存",
  "label.kansa.hi_kansa_bumon_store": "被監査部門回答登録",
  "label.kansa.answer_store": "回答登録",
  "label.kansa.kakunin_jiko": "確認事項",
  "label.kansa.kakunin_kekka": "確認結果",
  "label.kansa.kakunin_hosoku": "確認補足",
  "label.kansa.hakken_jiko_bunrui": "発見事項分類",
  "label.kansa.hakken_jiko": "発見事項",
  "label.kansa.sejukudo_hyoka": "成熟度評価",
  "label.kansa.kakunin_kekka_missing": "該当する調査項目グループの確認結果",
  "label.kansa.trail_register_missing": "証跡の登録に失敗しました。",
  "label.kansa.trail_update_missing": "証跡の更新に失敗しました。",
  "label.kansa.trail_download_data_missing": "対象の証跡管理情報は削除されている可能性があります。",
  "label.kansa.trail_download_file_missing": "対象の証跡ファイルは削除されている可能性があります。",
  "label.kansa.register_status_missing": "既に他のユーザが作成完了としているため、登録を行えません。\n・他のユーザの更新内容を確認する場合は一覧から再選択してください。",
  "label.kansa.kansa_answer_register_help": "・監査部門は全ての項目を入力可能です。<br/>・被監査部門は確認結果、確認補足、証跡のみ入力可能です。<br/>・被監査部門で監査回答を登録すると、監査回答状況が「回答中」になります。<br/>　監査部門で監査回答の成熟度評価を登録すると、監査回答状況が「回答済」になります。",
  "label.kansa.answer_kekka_hint": "確認事項に対する確認結果を選択します。補足があれば確認補足に入力します。",
  "label.kansa.answer_hakkenjiko_hint": "発見事項分類で「特記事項無し」以外を選択した場合は、発見事項を入力してください。",
  "label.kansa.answer_seijukudo_hint": "<span style=\"font-weight:bold\">成熟度レベル：</span><br/>\n        １：大規模災害時に継続する事業がない。<br/>\n        ２：場当たり的、俗人的な対処がされている状態。<br/>\n        ３：職場に暗黙的ルールしかない状態。<br/>\n        ４：ルールが制定、明文化されており関係者間で周知がされている。<br/>\n        ５：行動手順、復旧手順が作成され、継続的改善が行われている。<br/>\n        ６：組織の文化として定着化し、関係者外の組織内の担当にも周知がされている。",
  "label.kansa.return_to_progress": "進捗一覧へ戻る",
  "label.kansa.answer_temp_save": "監査回答を一時保存しました。",
  "label.kansa.progress_audited_evaluation_status": "被監査部門責任者評価",
  "label.kansa.kinyu_date": "記入日",
  "label.kansa.kinyusha_nm": "記入者",
  "label.kansa.comment": "コメント",
  "label.kansa.result_detail": "監査結果表示",
  "label.kansa.kaizen_preview": "改善計画表示",
  "label.kansa.temporarily_store": "一時保存",
  "label.kansa.hikansa_hyoka": "被監査部門責任者評価",
  "label.kansa.hikansa_hyoka_register": "被監査部門責任者評価登録",
  "label.kansa.hikansa_hyoka_register_result": "被監査部門責任者評価登録結果",
  "label.kansa.hikansa_hyoka_detail": "被監査部門責任者評価表示",
  "label.kansa.temporarily_save_confirm_message": "一時保存します。よろしいですか？",
  "label.kansa.kansa_temporarily_save_error_message": "他のユーザが評価完了としているため、一時保存を行えません。\n    ・変更した内容で保存する場合は登録ボタンを押下してください。\n    ・他のユーザの更新内容を確認する場合は一覧から再選択してください。",
  "label.kansa.delete_confirm_trail_message": "証跡を削除します。よろしいですか？",
  "label.kansa.hikokai_setting": "非公開設定",
  "label.kansa.keep_hikokai": "非公開情報とする",
  "label.kansa.not_keep_hikokai": "非公開情報としない",
  "label.kansa.target_register_title": "監査対象事業登録",
  "label.kansa.target_register_result": "監査対象事業登録結果",
  "label.kansa.select_tantososhiki_hint": "被監査部門は複数選択可能です。",
  "label.kansa.tantososhiki_note_hint": "選定した理由、対象外とした理由、対象業務などを記入できます。",
  "label.kansa.tgt_jigyo_nm_already_exists": "同じ被監査部門が含まれている同名の監査対象事業が既に存在するため、登録できません。",
  "label.kansa.ans_already_create": "監査対象事業は既に監査回答登録されているため、更新できません。",
  "label.kansa.no_kansa_tgt_jigyo": "該当する監査対象事業がありません。既に削除された可能性があります。",
  "label.kansa.tgt_nendo": "監査対象年度",
  "label.kansa.theme_nm": "監査テーマ",
  "label.kansa.tgt_jigyo_nm": "監査対象事業",
  "label.kansa.bumon": "監査部門",
  "label.kansa.hikansa_bumon": "被監査部門",
  "label.kansa.hikansabumon_push": "被監査部門追加",
  "label.kansa.progress_help": "検索条件を入力し、検索ボタンを押してください。",
  "label.kansa.progress_duties": "業務内容",
  "label.kansa.progress_auditor": "監査部門",
  "label.kansa.progress_auditee": "被監査部門",
  "label.kansa.progress_audit_target_year": "監査対象年度",
  "label.kansa.progress_audit_thema": "監査テーマ",
  "label.kansa.insert_confirm_trail_message": "証跡が登録されていません。",
  "label.kansa.notfound_confirm_trail_message": "該当する証跡がありません。",
  "label.kansa.kansa_progress_help": "<div style='margin: 0 0 8px 0'>監査の進捗状況を表示します。</div>\n    <br/>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>未対応は</div><div style='margin-left: 2px; text-align: center; height: auto; width:60px; background-color: #fadbda; '><span style='color: black; font-weight: bold'>　</span></div><div style='font-weight: bold;'>、対応中は</div><div style='margin-left: 2px; text-align: center; height: auto; width:60px; background-color: #ffffb3; '><span style='color: black; font-weight: bold'>　</span></div><div style='font-weight: bold;'>で表示されます。</div></div>\n    <br/>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>監査状況</div></div>\n    <div style='margin: 0 0 8px 8px'>・全ての監査業務が完了している場合または指摘事項改善計画の指摘事項がなくその他の監査業務が完了している場合、「完了」と表示されます。</div>\n    <div style='margin: 0 0 8px 8px'>・全ての監査業務が完了していない場合「未完了」と表示されます。</div>\n    <br/>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>進捗状況のリンク</div></div>\n    <div style='margin: 0 0 8px 8px'>登録/作成/表示が可能な進捗状況の場合は各登録/作成/表示画面を表示するリンクが表示されます。</div>",
  "label.kansa.progress": "監査進捗状況",
  "label.kansa.kansa_sts": "監査状況",
  "label.kansa.audit_results_creation_sts": "監査結果作成状況",
  "label.kansa.improvement_pointed_out_plan_sts": "指摘事項改善計画状況",
  "label.kansa.improvement_pointed_out_plan_progress": "指摘事項改善進捗状況",
  "label.kansa.audited_evaluation_sts": "被監査部門責任者評価評価状況",
  "label.kansa.progress_show_all": "全て表示する",
  "label.kansa.kansa_result_help": "<div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>監査部門</div></div>\n    <div style='margin: 0 0 8px 8px'>・監査結果を登録する。</div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績の作成状況、及び被監査部門責任者評価の登録状況を確認し、未完了の場合はフォローする。</div>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>被監査部門</div></div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績の作成および実績登録を行う。</div>\n    <div style='margin: 0 0 8px 8px'>・監査結果を確認し、被監査部門責任者評価を登録する。</div>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>監査結果 作成状況</div></div>\n    <div style='margin: 0 0 8px 8px'>・監査結果登録画面で、一時保存を行った場合は作成中となります。</div>\n    <div style='margin: 0 0 8px 8px'>・監査結果登録画面で、登録を行った場合は作成完了となります。</div>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>指摘事項改善 計画状況</div></div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績登録画面で、一部の指摘の計画策定時項目が入力された場合は作成中となります。</div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績登録画面で、全ての指摘の計画策定時項目が入力された場合は作成完了となります。</div>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>指摘事項改善 進捗状況</div></div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績登録画面で、一部の指摘の対応完了時項目が入力された場合は対応中となります。</div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績登録画面で、全ての指摘の対応完了時項目が入力された場合は対応完了となります。</div>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>被監査部門責任者評価 評価状況</div></div>\n    <div style='margin: 0 0 8px 8px'>・被監査部門責任者評価登録画面で、一時保存を行った場合は評価中となります。</div>\n    <div style='margin: 0 0 8px 8px'>・被監査部門責任者評価登録画面で、登録を行った場合は評価完了となります。</div>",
  "label.kansa.result_title": "監査結果",
  "label.kansa.result_register_title": "監査結果登録",
  "label.kansa.result_register_help": "<div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>一時保存／登録</div></div>\n    <div style='margin: 0 0 8px 8px'>・担当者の方は、一時保存ボタンを押下してください。</div>\n    <div style='margin: 0 0 8px 8px'>・登録ボタンは、押下すると作成完了となるため、責任者の方が押下してください。</div>",
  "label.kansa.result_refer_title": "監査結果表示",
  "label.kansa.result_refer_zennendo_title": "前年度 監査結果表示",
  "label.kansa.result_result_title": "監査結果登録結果",
  "label.kansa.result_Verification_result": "確認結果",
  "label.kansa.result_zennendo_hakken_jiko_bunrui": "前年度発見事項分類",
  "label.kansa.result_zennendo_hakken_jiko": "前年度発見事項",
  "label.kansa.result_report_date": "報告日",
  "label.kansa.result_report_name": "報告先",
  "label.kansa.result_shonin_date": "承認日",
  "label.kansa.result_shoninsha": "承認者",
  "label.kansa.result_kekka_sokatsu": "監査結果総括",
  "label.kansa.result_sogo_hyoka": "総合評価",
  "label.kansa.result_kansa_jissi_date": "内部監査実施日時",
  "label.kansa.result_kansa_jissi_place": "内部監査実施場所",
  "label.kansa.result_sokatsu": "総括",
  "label.kansa.result_zennendo_followup": "前年度 改善の機会・不適合（是正）事項フォローアップ",
  "label.kansa.result_honnendo_goodpoint": "本年度のグッドポイント",
  "label.kansa.result_honnendo_kaizen": "本年度の改善の機会",
  "label.kansa.result_honnendo_fuguai": "本年度の不具合",
  "label.kansa.result_honnendo_hutekigo": "前年度 改善の機会・不適合（是正）事項フォローアップ",
  "label.kansa.result_kansabumon_comment": "監査部門コメント",
  "label.kansa.result_temporarily_store": "一時保存",
  "label.kansa.result_gaiyo": "監査概要",
  "label.kansa.result_goodpoint": "グッドポイント",
  "label.kansa.result_honnendo_futekigo": "本年度の不適合",
  "label.kansa.result_handan_konkyo": "判断の根拠",
  "label.kansa.result_handan_kekka": "判断結果",
  "label.kansa.result_taisakurei": "対策例",
  "label.kansa.result_risk": "リスク",
  "label.kansa.result_followup_nodata": "「前年度 改善の機会・不適合（是正）事項フォローアップ」はありません。",
  "label.kansa.result_honnendo_nodata": "「{0}」に該当する事項はありません。",
  "label.kansa.result_seijukudo_nodata": "該当する成熟度評価がありません。",
  "label.kansa.result_seijukudo_check": "前回から成熟度の評価が変わっているため、一時保存または登録を行ってください。<br/><br/>新しいコメントに変更しますか？(OKを押すとコメントが変わります)",
  "label.kansa.result_seijukudo_check_regist": "他のユーザが成熟度の評価を変更したため、登録を行えません。\n一覧から再選択してください。",
  "label.kansa.result_ansdata_null_check": "監査回答時の情報を取得できなかったため、一時保存・登録を行えません。\n一覧から再選択して情報を取得し直してください。",
  "label.kansa.result_temp_save_check": "他のユーザが作成完了としているため、一時保存を行えません。\n・変更した内容で保存する場合は登録ボタンを押下してください。\n・他のユーザの更新内容を確認する場合は一覧から再選択してください。",
  "label.kansa.result_register_check": "他のユーザが監査回答を変更したため、{0}を行えません。\n一覧から再選択してください。",
  "label.kansa.result_registered_message_supplement": "登録内容に誤りがある場合は、再度、登録を行ってください。",
  "label.kansa.result_temp_save": "監査結果を一時保存しました。",
  "label.kansa.result_chosa_column_cd": "000",
  "label.kansa.result_comment_heder_sogohyoka": "総合評価コメント",
  "label.kansa.result_comment_heder_category": "カテゴリ別評価コメント",
  "label.kansa.result_chosa_column_nm": "［%s］について、",
  "label.kansa.preparation_message": "{0}年度の内部監査は、現在準備中です。",
  "label.kansa.send_mail_subject_ans": "[内部監査]被監査部門回答登録 （{0}）",
  "label.kansa.send_mail_subject_results": "[内部監査]指摘事項改善計画、被監査部門責任者評価登録依頼 （{0}）",
  "label.kansa.send_mail_subject_evaluation": "[内部監査]指摘事項改善計画、被監査部門責任者評価登録 （{0}）",
  "label.kansa.send_mail_subject_failure": "[内部監査]メール送信失敗 （{0}）",
  "label.kansa.send_mail_body_ans": "TO:{0} 様\nFM:OneNEC事業継続支援システム\n\n以下の監査対象事業について、被監査部門の監査回答が登録されました。\nOneNEC事業継続支援システムより被監査部門の監査回答を確認してください。\n監査対象事業名：{1}\n更新者：{2}({3})\nURL：{4}\n\n本メールは自動配信です。返信できませんのでご注意ください。\nお問い合わせ先：ITサービスポータル(https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91)",
  "label.kansa.send_mail_body_results": "TO:{0} 様\nFM:OneNEC事業継続支援システム\n\n以下の監査対象事業について、監査結果が登録されました。\n被監査部門担当者はOneNEC事業継続支援システムより\n指摘事項改善計画および被監査部門責任者評価を登録してください。\n監査対象事業名：{1}\n更新者：{2}({3})\nURL：{4}\n\n本メールは自動配信です。返信できませんのでご注意ください。\nお問い合わせ先：ITサービスポータル(https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91)",
  "label.kansa.send_mail_body_evaluation": "TO:{0} 様\nFM:OneNEC事業継続支援システム\n\n以下の監査対象事業について、指摘事項改善計画と被監査部門責任者評価が登録されました。\nOneNEC事業継続支援システムより確認してください。\n監査対象事業名：{1}\n更新者：{2}({3})\nURL：{4}\n\n本メールは自動配信です。返信できませんのでご注意ください。\nお問い合わせ先：ITサービスポータル(https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91)",
  "label.kansa.send_mail_body_failure": "TO:{0} 様\nFM:OneNEC事業継続支援システム\n\n以下の責任者／担当者へのメール送信が失敗しました。\n連絡が必要な場合は、お手数ですが個別で連絡を行ってください。\n　・{1}\n監査対象事業名：{2}\nURL：{3}\n\n本メールは自動配信です。返信できませんのでご注意ください。\nお問い合わせ先：ITサービスポータル(https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91)",
  "label.kansa.send_mail_add_err_shain_format": "　・{0}\n",
  "label.kansa.send_mail_add_err_address_format": "以下の担当者／責任者は、メールアドレスが設定されていないため、通知メールを送信できませんでした。\n連絡が必要な場合は、お手数ですが個別で連絡を行ってください。\n{0}",
  "label.kansa.send_mail_add_err_send_format": "以下の担当者／責任者は、メール送信エラーにより、通知メールを送信できませんでした。\n連絡が必要な場合は、お手数ですが個別で連絡を行ってください。\n{0}",
  "label.kansa.send_mail_err_msg_send_list": "メールアドレスが設定されている担当者／責任者がいないため、通知メールを送信しませんでした。",
  "label.kansa.send_mail_err_msg_exception": "通知メールの送信に失敗しました。お手数ですが、システムの管理者へご連絡ください。",
  "label.kansa.target_list": "監査対象事業一覧",
  "label.kansa.audit_target_business": "監査対象事業",
  "label.kansa.not_set_audit_department": "監査部門が未設定の監査対象事業のみ表示",
  "label.kansa.not_set_audited_department": "被監査部門が未設定の監査対象事業のみ表示",
  "label.kansa.full_name_audit_responsible_person": "監査部門責任者（姓名）",
  "label.kansa.full_name_audit_person_in_charge": "監査部門担当者（姓名）",
  "label.kansa.full_name_audited_responsible_person": "被監査部門責任者（姓名）",
  "label.kansa.full_name_audited_person_in_charge": "被監査部門担当者（姓名）",
  "label.kansa.audit_department": "監査部門",
  "label.kansa.audited_department": "被監査部門",
  "label.kansa.responsible_person": "責任者",
  "label.kansa.person_in_charge": "担当者",
  "label.kansa.select": "選択対象",
  "label.kansa.audit_status": "監査実施状況",
  "label.kansa.select_member": "責任者／担当者選択",
  "label.kansa.register_member": "更新・決定",
  "label.kansa.delete_confirm": "選択した監査対象事業を削除します。よろしいですか？",
  "label.kansa.register_complate": "責任者／担当者を登録しました。",
  "label.kansa.delete_complate": "監査対象事業を削除しました。",
  "label.kansa.non_selected": "責任者／担当者の選択対象が選択されていません。",
  "label.kansa.started": "着手済",
  "label.kansa.not_started": "未着手",
  "label.kansa_targetlist_help": "監査対象事業の一覧を表示し、監査部門責任者、監査部門担当者、被監査部門責任者、<br/>被監査部門担当者の登録・削除を行うことができます。<br/>\n    <br/>\n    <b>背景色が以下の場合</b><br/>\n    <table>\n      <tr><td rowspan=4 style=\"background-color:pink;\" width=\"40\" height=\"68\"></td></tr>\n      <td>監査部門、または被監査部門が未設定です。変更欄の　\n      <svg class=\"MuiSvgIcon-root-701\" focusable=\"false\" viewBox=\"0 0 24 24\" width=\"24\" height = \"24\" aria-hidden=\"true\" role=\"presentation\"><path d=\"M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z\"></path></svg>    \n  　をクリックして、</td>\n  <tr><td>監査対象事業登録画面から監査対象事業の更新を行ってください。</td></tr>\n  <tr><td>※監査業務が開始されている場合は、変更できなくなります。</td></tr>\n    </table>\n    <br/>\n    <b>監査部門／被監査部門の責任者／担当者の設定を変更する場合</b><br/>\n    ①設定したい欄の選択対象欄をチェックし、責任者／担当者選択ボタンをクリックします。<br/>\n    ※責任者は１人のみ設定可能であるため、既に設定されている場合は削除してから設定する必要があります。<br/>\n    ②表示された利用者選択画面で利用者を選択すると一覧に設定されます。<br/>\n    ※画面に設定した時点ではまだ登録されていません。<br/>\n    ③画面の設定内容を確認し、右下の責任者／担当者登録ボタンをクリックして登録を行います。<br/>\n    <br/>   \n    <b>監査対象事業を削除する場合</b><br/>\n    削除したい監査対象事業の削除欄をチェックし、右下の削除ボタンをクリックします。<br/>\n    ※監査業務が開始されている場合は、削除できなくなります。",
  "label.kansa.audit_department_select": "監査部門選択",
  "label.kansa.audited_department_select": "被監査部門選択",
  "label.kansa.audit_prev_year_info": "※{0}年度監査部門",
  "label.kansa.audited_prev_year_info": "※{0}年度被監査部門",
  "label.kansa.answerd_data": "以下の監査対象事業は既に監査回答されているため、削除できません。{0}",
  "label.kansa.report_summary": "監査報告サマリ",
  "label.kansa.report_search": "監査報告書",
  "label.kansa.complete_counts": "監査完了件数",
  "label.kansa.report_creation_status": "作成状況",
  "label.kansa.report_evaluation_status": "評価状況",
  "label.kansa.report_register": "監査報告書登録",
  "label.kansa.report_register_result": "監査報告書登録結果",
  "label.kansa.report_refer": "監査報告書表示",
  "label.kansa.report_detail": "監査報告詳細",
  "label.kansa.report_evaluation_register": "監査報告書評価登録",
  "label.kansa.report_evaluation_register_result": "監査報告書評価登録結果",
  "label.kansa.report_evaluation_refer": "監査報告書評価表示",
  "label.kansa.report_last_upd_user": "最終更新者",
  "label.kansa.report_last_upd_date": "最終更新日",
  "label.kansa.sejukudo_hyoka_summary": "成熟度評価サマリ",
  "label.kansa.kansabumon_comment": "監査部門コメント",
  "label.kansa.temporarily_save": "一時保存",
  "label.kansa.report_temporarily_saved": "監査報告書を一時保存しました。",
  "label.kansa.report_evaluation_temporarily_saved": "監査報告書評価を一時保存しました。",
  "label.kansa.kinyusha": "記入者",
  "label.kansa.report_ev_comment": "NEC関係部門長・関係会社社長コメント",
  "label.kansa.show_report": "報告書を表示",
  "label.kansa.hkn_bnr_grp_futekigo": "不適合",
  "label.kansa.hkn_bnr_grp_kaizen": "改善の機会",
  "label.kansa.hkn_bnr_judai": "重大",
  "label.kansa.hkn_bnr_keibi": "軽微",
  "label.kansa.hkn_bnr_kansatsu": "観察",
  "label.kansa.hkn_bnr_suisho": "推奨",
  "label.kansa.target_jigyo_not_found_message": "該当データが存在しません。",
  "label.kansa.report_target_jigyo_not_found": "該当する監査対象事業がありません。",
  "label.kansa.report_seijukudo_hyoka_not_found": "該当する成熟度評価がありません。",
  "label.kansa.unable_enter_future_date": "未来日は入力できません。",
  "label.kansa.push_complete_register": "登録完了通知",
  "label.kansa.push_mail": "{0}にメールで通知する",
  "label.kansa.send_mail_confirm": "（{0}に登録完了通知メールが自動送信されます）",
  "label.kansa.send_mail_confirm_shiteki_no_plan": "（計画状況が未完了です。監査部門に登録完了通知メールは送信されません。）",
  "label.bcm.bcp_formulation_title": "BCP策定",
  "label.bcm.document_mng_natural_disasters": "ドキュメント管理（自然災害）",
  "label.bcm.document_mng": "ドキュメント管理",
  "label.bcm.bcm_permission_setting": "対象事業利用ユーザ追加",
  "label.bcm.bcm_permission_setting_help": "対策本部権限のユーザに対して、利用可能なBCP対象事業を追加することができます。<br/>\n設定した会社／組織の全てのBCP対象事業が利用可能となります。",
  "label.bcm.add_kaisha_soshiki": "会社／組織追加",
  "label.bcm.delete_kaisha_soshiki": "会社／組織削除",
  "label.bcm.change_bcp_tgt_jigyo": "BCP対象事業変更",
  "label.bcm.available_kaisha_soshiki": "利用可能会社／組織名",
  "label.bcm.available_bcp_tgt_jigyo": "利用可能BCP対象事業名",
  "label.bcm.permission_setting_not_changed": "利用許可設定が変更されていません。",
  "label.bcm.already_add_kaisha_soshiki_message": "選択した会社／組織は既に追加されています。",
  "label.bcm.reffer_add_kaisha_soshiki_message": "選択した会社／組織は利用可能なため、追加できません。",
  "label.bcm.bcp_jisshi_policy": "実施方針",
  "label.bcm.bcp_kunren_guidance": "訓練実施要領・訓練シナリオ登録",
  "label.bcm.bcp_kunren_guidance_register_result": "訓練実施要領・訓練シナリオ登録結果",
  "label.bcm.bcp_kunren_guidance_delete_result": "訓練実施要領・訓練シナリオ削除結果",
  "label.bcm.bcp_scenario_policy": "シナリオ方針",
  "label.bcm.bcp_implementation_yotei_ate": "実施予定日時",
  "label.bcm.bcp_scenario_register": "シナリオ登録",
  "label.bcm.bcp_nec_scenario_check": "ＮＥＣ中央のシナリオとして登録する",
  "label.bcm.bcp_bu_scenario_check": "各社／各NEC関係部門共通のシナリオとして登録する",
  "label.bcm.scenario_regist": "登録する",
  "label.bcm.scenario_not_regist": "登録しない",
  "label.bcm.detail_view": "詳細表示",
  "label.bcm.document_mng_after_activation_review": "ドキュメント管理（発動後レビュー）",
  "label.bcm.bcp_tgt_jigyo_register": "BCP対象事業登録",
  "label.bcm.bcp_tgt_jigyo_register_result": "BCP対象事業登録結果",
  "label.bcm.bcp_tgt_jigyo_update": "BCP対象事業更新",
  "label.bcm.bcp_tgt_jigyo_update_result": "BCP対象事業更新結果",
  "label.bcm.bcp_tgt_organization": "対象組織",
  "label.bcm.bcp_tgt_organization_msg": "組織がなくなっています。再選択してください。",
  "label.bcm.bcp_tgt_organization_hint": "組織変更等により現在存在しない組織は「{0}」と表示されています。対象組織を変更してください。",
  "label.bcm.bcp_tgt_organization_select": "対象組織選択",
  "label.bcm.bcp_this_tgt_bcp_code_already_registered": "BCP対象事業コードは既に登録済みです。",
  "label.bcm.kunren": "訓練",
  "label.bcm.document_mng_kunren": "ドキュメント管理（訓練）",
  "label.bcm.review": "発動後レビュー",
  "label.bcm.kansa_guideline": "内部監査実施要領",
  "label.bcm.related_information": "関連情報",
  "label.bcm.kunren.medplan_title": "訓練中期計画登録",
  "label.bcm.kunren.medplan_result_title": "訓練中期計画登録結果",
  "label.bcm.kunren.medplan": "訓練中期計画",
  "label.bcm.kunren.medplan_kunren_nendo": "年度",
  "label.bcm.kunren.medplan_targetrisk_hint": "参加者に被災・行動の前提イメージを持たせるため、訓練で対象とするリスクを設定する。<br/>参加者に対応策が思いつかないようなリスクは設定しない方が望ましい。<br/><br/>■地震<br/>　震度6強の地震とそれが発生した際の地域情勢・インフラ被災を想定した対象リスク。<br/>■洪水<br/>　洪水による被災を想定した対象リスク。台風、局地豪雨、大雪もこのカテゴリーに含める。<br/>■感染症<br/>　季節性インフルエンザ（A型、B型等）ではなく、新型インフルエンザ等強毒性感染症の発生を想定した対象リスク。<br/>■その他<br/>　地震、洪水、感染症以外の災害を想定した対象リスク。津波、テロ、火災、噴火、原子力事故など。",
  "label.bcm.kunren.medplan_kunrenseason_hint": "リスク発生時から平常の業務体制に戻るまでの時期により、行動すべき内容が変わるため、今回の訓練で想定する時期を設定する。<br/>感染症は時間軸で区切らずに、その広まり具合で時期を分ける。<br/><br/>■初動<br/>　感染症以外の自然災害のリスク発生後から初期対応を行うまで時期を想定。<br/>　主に発生から3日間。<br/>■復旧<br/>　感染症以外の自然災害のリスク発生後、初動が一段落し本格的に復旧業務を行う時期を想定。<br/>　主にリスク発生後3～10日目。<br/>　（早期対応業務では6H～5日目をさす場合もある）<br/>■国内感染症早期<br/>　海外で発生した強毒性の感染症が国内でも発生し始めた時期を想定。<br/>　感染者は公的機関から強制隔離措置を取られる。また、必要に応じ職場閉鎖が行われる時期。<br/>■国内感染期（蔓延期）<br/>　感染が拡大し国が蔓延期を宣言した時期を想定。<br/>　少ない人数での業務の維持・管理が求められる。",
  "label.bcm.kunren_medplan_tgtrisk_err": "当該訓練年度の対象リスクを選択してください。",
  "label.bcm.kunren_no_registered": "訓練中期計画未登録",
  "label.bcm.kunren_report_register": "訓練実施報告登録",
  "label.bcm.kunren_report_register_result": "訓練実施報告登録結果",
  "label.bcm.kunren_report_delete_result": "訓練実施報告削除結果",
  "label.bcm.kunren_report_jisshi_detail": "実施詳細",
  "label.bcm.kunren_report_file_duplicate_message": "参加者名等ファイル名が重複しています。",
  "label.bcm.kunren_report_jisshi_detail_help": "シナリオ方針が「NEC中央のシナリオで訓練する」の場合、NEC中央のシナリオが更新されたら実施詳細に反映されます。<br/>\n    シナリオ方針が「各社／各NEC関係部門共通のシナリオで訓練する」の場合、各社／各NEC関係部門共通のシナリオが更新されたら実施詳細に反映されます。",
  "label.bcm.kunren_scenario_policy_help": "訓練の進める上でのシナリオを選択する。<br/>\n    <br/>\n    ■NEC中央のシナリオで訓練する<br/>　NEC中央事業継続対策本部が作成するシナリオで訓練を行う場合、これを選択する。<br/>\n    ■各社／各NEC関係部門共通のシナリオで訓練する<br/>　各社／各NEC関係部門の共通訓練方針に基づいて訓練をする場合、これを選択する。<br/>\n    ■部門独自のシナリオで訓練する<br/>　各部門が独自の検証項目、検証事項を訓練する場合、これを選択する。",
  "label.bcm.kunren_report_task_title": "課題の抽出",
  "label.bcm.kunren_report_task_title_help": "訓練で検証し判明した課題について入力する。<br/>\n    （入力した内容は今後「課題管理表」に反映予定）<br/>\n    複数の課題を入力する場合は、「課題入力欄追加」ボタンを押下する。",
  "label.bcm.kunren_report_checksheet_result": "BCP訓練チェックシート集計結果",
  "label.bcm.kunren_report_checksheet_result_help": "別途訓練チェックシートで訓練後のヒアリングを行い、訓練の理解度、有効性を記載する。<br/>\n    ・「理解度」「有効性」欄は3点満点評価（1：不十分である、2：一応、十分であるが改善すべき課題がある、3：十分である）<br/>\n    ・チーム複数参加者の平均点2.7以上は青字表記、2.3以下は赤字表記とする",
  "label.bcm.kunren_report_comment_title": "訓練目的達成度評価、対策本部長コメント",
  "label.bcm.kunren_jisshi_dt": "実施日時",
  "label.bcm.kunren_tgt_risk": "対象リスク",
  "label.bcm.kunren_report_tgt_risk_hint": "参加者に被災・行動の前提イメージを持たせるため、訓練で対象とするリスクを設定する。<br/>\n    参加者に対応策が思いつかないようなリスクは設定しない方が望ましい。<br/>\n    <br/>\n    ■地震<br/>\n    　震度6強の地震とそれが発生した際の地域情勢・インフラ被災を想定した対象リスク。<br/>\n    ■洪水<br/>\n    　洪水による被災を想定した対象リスク。台風、局地豪雨、大雪もこのカテゴリーに含める。<br/>\n    ■感染症<br/>\n    　季節性インフルエンザ（A型、B型等）ではなく、新型インフルエンザ等強毒性感染症の発生を想定した対象リスク。<br/>\n    ■その他<br/>\n    　地震、洪水、感染症以外の災害を想定した対象リスク。津波、テロ、火災、噴火、原子力事故など。<br/>",
  "label.bcm.kunren_tgt_risk_detail": "対象リスク詳細",
  "label.bcm.kunren_report_tgt_risk_detail_hint": "訓練の対象となるリスク（地震、洪水、感染症、その他）を具体的に入力する。<br/>\n    例：地震　○○地域直下地震、東海地震、首都直下地震など<br/>\n    　　洪水　○○川の氾濫、　反乱地域・・・・<br/>\n    　　感染症　○○病、致死率△％・・・<br/>",
  "label.bcm.kunren_period": "訓練時期",
  "label.bcm.kunren_report_period_hint": "リスク発生時から平常の業務体制に戻るまでの時期により、行動すべき内容が変わるため、今回の訓練で想定する時期を設定する。<br/>\n    感染症は時間軸で区切らずに、その広まり具合で時期を分ける。<br/>\n    <br/>\n    ■初動<br/>\n    　感染症以外の自然災害のリスク発生後から初期対応を行うまで時期を想定。<br/>\n    　主に発生から3日間。<br/>\n    ■復旧<br/>\n    　感染症以外の自然災害のリスク発生後、初動が一段落し本格的に復旧業務を行う時期を想定。<br/>\n    　主にリスク発生後3～10日目。<br/>\n    　（早期対応業務では6H～5日目をさす場合もある）<br/>\n    ■国内感染症早期<br/>\n    　海外で発生した強毒性の感染症が国内でも発生し始めた時期を想定。<br/>\n    　感染者は公的機関から強制隔離措置を取られる。また、必要に応じ職場閉鎖が行われる時期。<br/>\n    ■国内感染期（蔓延期）<br/>\n    　感染が拡大し国が蔓延期を宣言した時期を想定。<br/>\n    　少ない人数での業務の維持・管理が求められる。",
  "label.bcm.kunren_purpose": "訓練目的",
  "label.bcm.kunren_content": "訓練内容",
  "label.bcm.kunren_supplement": "補足事項",
  "label.bcm.kunren_year_tgt_risk": "当該訓練年度の対象リスク",
  "label.bcm.kunren_participant": "参加人数",
  "label.bcm.kunren_participant_list": "参加者名等",
  "label.bcm.kunren_report_participant_list_hint": "訓練に参加した人の名簿。EXCEL等で一覧が望ましい。<br/>\n    部門全員であれば「部門全員　○名」という記述でも良いが、対策本部員などであれば、対策本部員全員の名前に、参加者は○をするなどの工夫をすること。",
  "label.bcm.kunren_result": "訓練成果（グッドポイント）",
  "label.bcm.kunren_task_bumon": "対応部門",
  "label.bcm.kunren_task_kind": "種別",
  "label.bcm.kunren_task_taio": "対応の方向性",
  "label.bcm.kunren_task_schedule": "完了予定時期",
  "label.bcm.kunren_task": "課題",
  "label.bcm.kunren_task_add": "課題入力欄を追加",
  "label.bcm.kunren_checksheet_team_nm": "チーム名",
  "label.bcm.kunren_checksheet_reply": "回答数",
  "label.bcm.kunren_checksheet_understand": "理解度",
  "label.bcm.kunren_checksheet_effect": "有効性",
  "label.bcm.kunren_checksheet_comment": "コメント",
  "label.bcm.kunren_checksheet_team_add": "チーム追加",
  "label.bcm.kunren_checksheet_average": "全体の平均",
  "label.bcm.kunren_checksheet_previous": "（参考）前回評価",
  "label.bcm.kunren_evaluation": "訓練目的達成度評価",
  "label.bcm.kunren_evaluation_comment": "対策本部長コメント",
  "label.bcm.kunren_participant_etc": "参加者名等",
  "label.bcm.kunren_medplan_sts": "訓練中期計画（進捗状況）",
  "label.bcm.kunren_medplan_reg_dt": "訓練中期計画（登録日）",
  "label.bcm.kunren_guidelines_sts": "訓練実施要領/訓練シナリオ（進捗状況）",
  "label.bcm.kunren_guidelines_reg_dt": "訓練実施要領/訓練シナリオ（登録日）",
  "label.bcm.kunren_report_sts": "訓練実施報告（進捗状況）",
  "label.bcm.kunren_report_reg_dt": "訓練実施報告（登録日）",
  "label.bcm.kunren_hosoku_doc_nm": "訓練補足資料（ファイル名）",
  "label.bcm.kunren_hosoku_doc_note": "訓練補足資料（説明書き）",
  "label.bcm.kunren_hosoku_doc_sts": "訓練補足資料（進捗状況）",
  "label.bcm.kunren_hosoku_doc_up_dt": "訓練補足資料（アップロード日時）",
  "label.bcm.kunren_task_csv_download_label": "訓練課題をCSVファイル形式で出力",
  "label.bcm.kunren_scenario": "訓練シナリオ",
  "label.bcm.bcp_tgt_jigyo_search": "BCP対象事業検索",
  "label.bcm.bcp_tgt_jigyo_delete": "BCP対象事業削除",
  "label.bcm.bcp_tgt_jigyo_delete_result": "BCP対象事業削除結果",
  "label.bcm.temp_save_check": "他のユーザが登録済としているため、一時保存を行えません。\n・変更した内容で保存する場合は登録ボタンを押下してください。\n・他のユーザの更新内容を確認する場合は一覧から再選択してください。",
  "label.bcm.bcp_tgt_jigyo_cd_hint": "英数3桁で「BCP対象事業参照」より、既存の番号以外を設定してください。",
  "label.bcm.bcp_map_create": "対策本部員参集支援マップ作成",
  "label.bcm.bcm_map": "対策本部員参集支援マップ",
  "label.bcm.bcm_map_map_create": "対策本部員参集支援マップ（マップ作成）",
  "label.bcm.bcp_search": "BCP検索",
  "label.bcm.bcm_map_search": "対策本部員参集支援マップ（BCP検索）",
  "label.bcm.bcp_search_help": "マップ情報の詳細を閲覧する場合は、ＢＣＰを検索後に詳細アイコンを押してください。<br/>\n    ※対策本部員参集支援マップ機能を利用している間の操作はログに記録されます。",
  "label.bcm.bcm_map_edit": "マップ情報編集",
  "label.bcm.bcm_map_edit_help": "マップ情報を変更した場合は、「確定」ボタンを押してください。",
  "label.bcm.bcp_no": "BCP番号",
  "label.bcm.enrollment": "登録人数",
  "label.bcm.admittee": "許可人数",
  "label.bcm.hq_location": "対策本部設置場所",
  "label.bcm.hq_first_choice_location": "第一候補",
  "label.bcm.hq_second_choice_location": "第二候補",
  "label.bcm.hq_third_choice_location": "第三候補",
  "label.bcm.hq_roll": "対策本部員役割",
  "label.bcm.map_disp_allow": "表示許可",
  "label.bcm.hq_member_no_added_message": "対策本部員が追加されていません。",
  "label.bcm.hq_member_add": "対策本部員追加",
  "label.bcm.hq_location_setting": "対策本部設置場所設定",
  "label.bcm.hq_location_setting_help": "地図上から任意の位置を指定し、名称を入力して「確定」ボタンを押してください。<br/>\n    拠点の位置や名称を引用する場合は、「拠点選択」ボタンを押してください。",
  "label.bcm.hq_location_name": "名称",
  "label.bcm.hq_member": "●対策本部員情報",
  "label.bcm.bcm_information": "●対策本部情報",
  "label.bcm.bcm_map_determine_message": "マップ情報を確定します。よろしいですか？",
  "label.bcm.bcm_map_detail_message": "変更された内容は確定されません。よろしいですか？",
  "label.bcm.hq_duplicate_register": "追加した対策本部員は、既に登録されています。",
  "label.bcm.map_disp_allow_null": "未設定",
  "label.bcm.bcm_map_print": "マップ印刷",
  "label.bcm.bcm_list_print": "リスト印刷",
  "label.bcm.bcm_list_print_title": "対策本部員参集支援リスト",
  "label.bcm.bcm_print": "印刷",
  "label.bcm.bcm_print_confirm": "印刷物には個人情報が含まれるため、取り扱いには特に注意してください。<br/>この操作はログに記録されます。",
  "label.bcm.bcm_map_name_switch": "対策本部員の姓名を表示する",
  "label.bcm.bcm_map_type_switch": "拠点ごとに同心円の種類を変える",
  "label.bcm.bcm_map_disp": "表示",
  "label.bcm.bcm_map_bcpno": "BCP番号：",
  "label.bcm.bcm_map_note": "備考：",
  "label.bcm.bcm_map_create_day": "作成日：",
  "label.bcm.bcm_map_square": "■",
  "label.bcm.bcm_map_under10": "10.0km未満",
  "label.bcm.bcm_map_under15": "10.0 - 14.9km",
  "label.bcm.bcm_map_under20": "15.0 - 19.9km",
  "label.bcm.bcm_map_over20": "20.0km以上",
  "label.bcm.bcm_map_dis_etc": "その他",
  "label.bcm.bcm_map_dis_sum": "合計",
  "label.bcm.bcm_map_hito": "人",
  "label.bcm.bcm_map_member_l": "対策本部長・副本部長",
  "label.bcm.bcm_map_member_m": "事務局",
  "label.bcm.bcm_map_member_s": "その他",
  "label.bcm.bcm_map_site_nosellect": "拠点が未選択です。",
  "label.bcm.bcm_map_dis_info": "距離別社員情報",
  "label.bcm.bcm_list_print_nodata": "未選択",
  "label.bcm.bcm_list_first": "第一候補拠点との距離",
  "label.bcm.bcm_list_second": "第二候補拠点との距離",
  "label.bcm.bcm_list_third": "第三候補拠点との距離",
  "label.bcm.bcm_list_km": "km",
  "label.bcm.bcm_print_gaihi": "【関係者外秘】",
  "label.bcm.bcm_map_detail": "マップ情報詳細",
  "label.bcm.bcm_map_create": "マップ作成",
  "label.bcm.hq_member_hint": "対策本部員を追加する場合は、「対策本部員追加」ボタンを押してください。<br/>\n    また、削除する場合は、削除するユーザにチェックを入れてください。",
  "label.bcm.bcm_map_update_message": "マップ情報を更新しました。"
};